(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  /* ---------------- Utilities ---------------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    /* Matches the money_without_trailing_zeros filter the product templates
       now use: a whole amount loses its .00, anything with real cents keeps
       them. This function only ever writes product prices (the price block,
       the sticky bar, the inline variant price), never cart or shipping
       figures, so it can drop the zeros without touching amounts a buyer
       reconciles against a statement. The two sides have to agree or the
       price visibly reformats the moment an interior is picked. */
    if (parts[1] !== '00') formatted += '.' + parts[1];
    if (placeholder.test(moneyFormat)) {
      value = moneyFormat.replace(placeholder, formatted);
    } else {
      value = '$' + formatted;
    }
    return value;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Option values self-describe ("Carbon Black Interior", not "Carbon Black")
     so Shopify's own surfaces never show an ambiguous "Black / Carbon Black"
     at checkout. The theme keeps that full name for interior colors too - only
     "Exterior" is dropped, since every visible label already says "Exterior"
     and "Black Exterior" would stutter against it. */
  /* Selection lived in a CSS class and nowhere else, which assistive tech
     cannot see: two buttons that sound identical with nothing saying which is
     active, on the control that gates checkout. Mirrors the class into
     aria-pressed. Paints nothing. */
  function markPressed(group, selectedBtn) {
    qsa('.product-option__value', group).forEach(function (b) {
      if (b.hasAttribute('aria-pressed')) {
        b.setAttribute('aria-pressed', b === selectedBtn ? 'true' : 'false');
      }
    });
  }

  function shortOptionValue(v) {
    return String(v || '').replace(/\s+Exterior$/i, '');
  }

  /* ---------------- One-tap buy ------------------------------------------
     Shared by the sticky buy bar and the interior choice cards so the two
     never drift apart. Adds the variant and goes straight to checkout; on any
     failure it falls back to the cart permalink, which adds the variant
     server-side even when the AJAX call was blocked. A shopper is never left
     on a dead button. */
  /* ---------------- Which button built the order ------------------------
     Written onto the cart as attributes, so every order in admin says under
     Additional details which button put the case in the bag ("Entry") and
     what the shopper did with the second-case offer. Nothing leaves the
     store: these are the cart's own fields, the same ones the holiday pages
     already use for their landing stamp. Writes are queued so a quick
     "Shown" then "Declined" can never land out of order, and the returned
     promise never rejects - a failed stamp must not cost a sale. */
  var stampQueue = Promise.resolve();
  function stampCart(attrs) {
    stampQueue = stampQueue.then(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    }).then(function () {}, function () {});
    return stampQueue;
  }
  /* For the moments a navigation is waiting on the stamp: give it a beat,
     never more. */
  function stampThen(attrs, go) {
    var done = false;
    var finish = function () { if (!done) { done = true; go(); } };
    stampCart(attrs).then(finish);
    window.setTimeout(finish, 1500);
  }

  function buyNow(el, variantId, entry) {
    if (!variantId || el.classList.contains('is-busy') || el.disabled) return;
    el.classList.add('is-busy');
    el.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      if (entry) {
        return new Promise(function (resolve) { stampThen({ 'Entry': entry }, resolve); });
      }
    }).then(function () {
      /* Straight to checkout skipped the one place the order limit is
         enforced. Six already in the bag plus this one went through as
         seven, past the last per-box shipping band. Over the limit, the
         shopper goes to the bag instead, which says why. */
      return fetch('/cart.js').then(function (c) { return c.json(); }).catch(function () { return null; });
    }).then(function (cart) {
      var max = parseInt(window.theme && window.theme.maxOrderUnits, 10);
      if (max > 0 && cart && cart.item_count > max) {
        window.location.href = (routes.cartUrl || '/cart');
        return;
      }
      window.location.href = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'checkout'
        : '/checkout';
    }).catch(function () {
      window.location.href = '/cart/' + variantId + ':1';
    });
  }

  /* ---------------- Force-mute every video, no exceptions ---------------- */
  function forceMute(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.removeAttribute('autoplay-with-sound');
    video.addEventListener('volumechange', function () {
      if (!video.muted) video.muted = true;
    });
  }

  /* ---------------- Set playback rate per clip, wherever it appears ----------------
     This list used to be named for slowing things down, which stopped being
     true the moment a clip needed quickening instead. Matched on the video's
     id inside its CDN url, so a clip keeps its rate on whatever surface it
     turns up. Reapplied on loadedmetadata in prepVideo, because an element
     resets playbackRate to 1 every time it loads new media. */
  var VIDEO_RATES = [
    { match: '3b363140b2b84f39bc7b527256d2c9fa', rate: 0.67 }, /* Three ways to carry: slowed */
    { match: 'f03fdc3ae9654c728f626cd249c8c08d', rate: 1.25 }  /* Second-case upsell, the pair walking: quickened */
  ];
  function applySlowRate(video) {
    var src = video.currentSrc || video.getAttribute('src') || '';
    for (var i = 0; i < VIDEO_RATES.length; i++) {
      if (src.indexOf(VIDEO_RATES[i].match) !== -1) {
        video.playbackRate = VIDEO_RATES[i].rate;
        break;
      }
    }
  }
  /* ---------------- Autoplay a viewer can actually stop ----------------
     Every automatic play in the theme goes through autoPlay and every
     automatic pause through autoPause, so that a viewer who hits pause on a
     video with visible controls stays paused. Without the pair, the next
     scroll past it, or the next return to its gallery slide, would start the
     clip up again underneath them. WCAG 2.2.2 asks for a way to stop
     anything that moves for more than five seconds, and a stop control that
     gets overridden a moment later is not one.

     The pause event fires asynchronously, so the intent is marked on the
     element and cleared by the handler rather than around the pause() call
     itself. A video reaching its own end is not a viewer stopping it, so
     that case is let through and the clip can play again later. */
  function trackManualPause(video) {
    video.addEventListener('pause', function () {
      if (video.solAutoPausing) { video.solAutoPausing = false; return; }
      if (video.ended) return;
      video.solStoppedByViewer = true;
    });
    video.addEventListener('play', function () { video.solStoppedByViewer = false; });
  }
  function autoPlay(video, fromStart) {
    if (video.solStoppedByViewer) return;
    if (fromStart) video.currentTime = 0;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }
  function autoPause(video) {
    if (video.paused) return;
    video.solAutoPausing = true;
    video.pause();
  }

  function prepVideo(video) {
    forceMute(video);
    applySlowRate(video);
    trackManualPause(video);
    video.addEventListener('loadedmetadata', function () { applySlowRate(video); });
  }
  qsa('video').forEach(prepVideo);
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'VIDEO') prepVideo(node);
          qsa('video', node).forEach(prepVideo);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------------- Lazy video sources ----------------
     Videos below the fold carry data-lazy-src (on the video, or on its
     <source>s for media_tag output) instead of src, so the home page's
     phone hero isn't splitting a mobile connection with six other clips
     at load. Each gets its real source once it comes within 600px of the
     screen. A video inside a closed dialog has no box and never
     intersects, so it loads when the dialog opens. Its poster shows until
     then, and autoplay takes over once the data arrives. */
  function loadLazyVideo(video) {
    var sources = qsa('source[data-lazy-src]', video);
    sources.forEach(function (s) {
      s.src = s.getAttribute('data-lazy-src');
      s.removeAttribute('data-lazy-src');
    });
    if (video.hasAttribute('data-lazy-src')) {
      video.src = video.getAttribute('data-lazy-src');
      video.removeAttribute('data-lazy-src');
    } else if (sources.length) {
      video.load();
    }
  }
  var lazyVideos = qsa('video[data-lazy-src]');
  qsa('video > source[data-lazy-src]').forEach(function (s) {
    if (lazyVideos.indexOf(s.parentNode) === -1) lazyVideos.push(s.parentNode);
  });
  if (lazyVideos.length) {
    if ('IntersectionObserver' in window) {
      var lazyVideoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          lazyVideoObserver.unobserve(entry.target);
          loadLazyVideo(entry.target);
        });
      }, { rootMargin: '600px 0px' });
      lazyVideos.forEach(function (v) { lazyVideoObserver.observe(v); });
    } else {
      lazyVideos.forEach(loadLazyVideo);
    }
  }

  /* ---------------- Autoplay videos: play only while on screen ---------------- */
  if ('IntersectionObserver' in window) {
    var autoplayVideos = qsa('video[autoplay]').filter(function (v) {
      return !v.closest('.key-features__media');
    });
    if (autoplayVideos.length) {
      var playObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            autoPlay(v);
          } else {
            autoPause(v);
          }
        });
      }, { threshold: 0.2 });
      autoplayVideos.forEach(function (v) { playObserver.observe(v); });
    }
  }

  /* ---------------- Scroll reveal (feature cards, testimonials, gallery) ---------------- */
  var revealTargets = qsa('.feature-card, .testimonial-card, .lifestyle-gallery__item');
  if (revealTargets.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 25% 0px' });
    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-in-view'); });
  }

  /* ---------------- Key features: pinned scroll showcase (Apple-style) ---------------- */
  var kfScroller = qs('[data-key-features-scroller]');
  if (kfScroller) {
    var kfSlides = qsa('[data-key-features-slide]', kfScroller);
    var kfImages = qsa('[data-key-features-image]', kfScroller);
    var kfSteps = kfSlides.length;
    var kfActiveIndex = 0;

    var kfReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var updateKeyFeatures = function () {
      if (window.innerWidth <= 989 || !kfSteps) return;
      if (kfReduceMotion.matches) {
        kfSlides.forEach(function (slide) { slide.classList.add('is-active'); });
        kfImages.forEach(function (img) { img.classList.add('is-active'); });
        return;
      }
      var rect = kfScroller.getBoundingClientRect();
      var scrollerTop = rect.top + window.scrollY;
      var scrollerHeight = kfScroller.offsetHeight;
      var viewportHeight = window.innerHeight;
      var pinnedDistance = Math.max(scrollerHeight - viewportHeight, 1);
      var progress = (window.scrollY - scrollerTop) / pinnedDistance;
      progress = Math.max(0, Math.min(1, progress));
      var index = Math.min(kfSteps - 1, Math.floor(progress * kfSteps));
      if (index !== kfActiveIndex) {
        kfSlides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
        kfImages.forEach(function (img, i) {
          var isActive = i === index;
          img.classList.toggle('is-active', isActive);
          var video = img.querySelector('video');
          if (video) {
            if (isActive) {
              video.currentTime = 0;
              var playPromise = video.play();
              if (playPromise && playPromise.catch) playPromise.catch(function () {});
            } else {
              video.pause();
            }
          }
        });
        kfActiveIndex = index;
      }
    };

    if ('IntersectionObserver' in window) {
      var kfVisObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          kfImages.forEach(function (img, i) {
            var video = img.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting && i === kfActiveIndex) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!entry.isIntersecting) {
              video.pause();
            }
          });
        });
      }, { threshold: 0.1 });
      kfVisObserver.observe(kfScroller);
    }

    /* Mobile: the pinned showcase is off and autoplay is gone, so play each
       slide's video only while it is on screen. Keeps the page from buffering
       ten 1080p clips at once on a phone. */
    if ('IntersectionObserver' in window) {
      var kfMobileObserver = new IntersectionObserver(function (entries) {
        if (window.innerWidth > 989) return;
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            if (video.preload !== 'auto') video.preload = 'auto';
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25, rootMargin: '200px 0px' });
      qsa('[data-kf-mobile-media]', kfScroller).forEach(function (el) { kfMobileObserver.observe(el); });
    }

    var kfTicking = false;
    window.addEventListener('scroll', function () {
      if (kfTicking) return;
      kfTicking = true;
      requestAnimationFrame(function () { updateKeyFeatures(); kfTicking = false; });
    }, { passive: true });
    window.addEventListener('resize', debounce(updateKeyFeatures, 150));
    updateKeyFeatures();
  }

  /* ---------------- Header / mobile menu ---------------- */
  var header = qs('[data-header]');
  var menuToggle = qs('[data-menu-toggle]');
  var mobileMenu = qs('[data-mobile-menu]');
  if (menuToggle && header) {
    menuToggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('is-menu-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      /* The panel collapses with max-height, not display:none, so without
         this its links stay in the tab order while invisible. inert takes
         the subtree out of focus and out of the accessibility tree
         together; aria-hidden shadows it for browsers that predate inert. */
      if (mobileMenu) {
        mobileMenu.toggleAttribute('inert', !isOpen);
        mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }
    });
  }

  var lastScroll = 0;
  window.addEventListener('scroll', debounce(function () {
    if (!header) return;
    var y = window.scrollY || window.pageYOffset;
    header.classList.toggle('is-scrolled', y > 12);
    lastScroll = y;
  }, 40), { passive: true });

  /* ---------------- Modal focus management ----------------
     An overlay that covers the page has to take focus with it, keep focus
     inside while it is open, and hand focus back to whatever opened it.

     None of that was happening. Tabbing the live site: adding to cart left
     focus on <body>, and the next six Tab presses walked through the
     product page UNDERNEATH the drawer - the California Prop 65 summary,
     the interior cards, the accordion triggers - all of it invisible behind
     the overlay. Escape closed the drawer but dropped focus wherever it had
     wandered to.

     The <body> part has a specific cause worth keeping in mind when editing
     the add-to-cart handler: it disables the submit button while the request
     is in flight, and disabling the focused element sends focus to <body>.
     That is why the opener is captured before the add starts, not after.
     ------------------------------------------------------------------- */
  var FOCUSABLE_SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex^="-"])';

  function focusablesIn(container) {
    return qsa(FOCUSABLE_SEL, container).filter(function (el) {
      if (el.closest('[inert]')) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 || r.height > 0;
    });
  }

  /* Returns a release function. Call it when the overlay closes. */
  function trapFocus(container, opener) {
    if (!container) return function () {};

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      var list = focusablesIn(container);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      var active = document.activeElement;

      /* Focus sitting outside the overlay is the case that actually bit
         here, so it is handled first rather than as an edge case. */
      if (!container.contains(active)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
        return;
      }
      if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    }

    /* Capture phase: this has to settle where focus goes before any other
       keydown listener gets a say. */
    document.addEventListener('keydown', onKeydown, true);

    var list = focusablesIn(container);
    if (list.length) {
      try { list[0].focus(); } catch (err) {}
    } else {
      /* Nothing focusable inside - an empty cart, for instance - so the
         container itself takes focus rather than leaving it on <body>. */
      container.setAttribute('tabindex', '-1');
      try { container.focus(); } catch (err) {}
    }

    return function release() {
      document.removeEventListener('keydown', onKeydown, true);
      if (opener && document.contains(opener) && opener.offsetParent !== null) {
        try { opener.focus(); } catch (err) {}
      }
    };
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = qs('#cart-drawer');
  var cartDrawerBody = qs('#CartDrawerBody');
  var cartCountEls = qsa('[data-cart-count]');

  var releaseCartFocus = null;
  function openCartDrawer(opener) {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (releaseCartFocus) releaseCartFocus();
    /* Deferred a frame: the drawer body is re-rendered by the add, and
       focusing a node that is about to be replaced puts focus back on
       <body> the moment it is. */
    var target = opener || null;
    requestAnimationFrame(function () {
      releaseCartFocus = trapFocus(cartDrawer, target);
    });
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (releaseCartFocus) { releaseCartFocus(); releaseCartFocus = null; }
    document.documentElement.style.overflow = '';
  }
  qsa('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(btn); });
  });
  /* Assigned further down, where the second-case dialog is set up. Declared
     here because the handlers between this point and there have to be able
     to ask it whether it wants the click first, and a function declared
     later in the same scope is not in scope for them at parse time but is
     by the time anything is clicked. Null when the dialog is switched off
     or absent, which is why every call site tests it. */
  var offerSecondCase = null;
  document.addEventListener('click', function (e) {
    var closer = e.target.closest && e.target.closest('[data-cart-close]');
    if (!closer) return;
    /* Closing the bag is leaving it, and leaving is exactly when the offer
       is worth making. If it takes the click, the drawer stays open behind
       the dialog and closes only once the shopper has answered. */
    if (offerSecondCase && offerSecondCase(closer, closeCartDrawer)) return;
    closeCartDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    /* The second-case dialog opens on top of the drawer and has its own
       Escape. Without this guard both fire and one keypress closes the
       dialog AND the drawer underneath it, which is not what dismissing a
       dialog means. */
    var upsellOpen = qs('[data-cart-upsell].is-open');
    if (upsellOpen) return;
    closeCartDrawer();
  });

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      var changed = el.textContent !== String(count);
      el.textContent = count;
      el.classList.toggle('is-hidden', count === 0);
      if (changed && count > 0) {
        el.classList.remove('is-pulsing');
        void el.offsetWidth;
        el.classList.add('is-pulsing');
      }
    });
  }

  function renderCartDrawer(sectionsHtml) {
    if (cartDrawerBody && sectionsHtml && sectionsHtml['cart-drawer']) {
      cartDrawerBody.innerHTML = sectionsHtml['cart-drawer'];
    }
  }

  /* The whole cart, not just its count. The second-case offer has to decide
     whether to interrupt on the click itself, and a fetch standing between a
     shopper and the checkout button is not a trade worth making: if this is
     stale or missing, the offer simply does not fire and the link behaves
     like a link. */
  var cartState = null;
  function fetchCartAndRender() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartState = cart; updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* Answer a press on the not-yet-enabled buy button by showing WHICH step is
     missing. Walks every option row that has no selection - not just the first -
     so a product with two open options flags both. */
  function nudgeMissingOptions(scope) {
    var groups = qsa('[data-fp-option-index], [data-option-index]', scope);
    var firstRow = null;
    groups.forEach(function (group) {
      if (group.querySelector('.is-selected')) return;
      var row = group.closest('.product-option');
      if (!row) return;
      if (!firstRow) firstRow = row;
      /* Drop and reflow before re-adding, so a second press restarts the
         animation instead of being swallowed as "class already present". */
      row.classList.remove('product-option--nudge');
      void row.offsetWidth;
      row.classList.add('product-option--nudge');
      window.setTimeout(function () { row.classList.remove('product-option--nudge'); }, 2400);
    });
    if (!firstRow) return;
    var rect = firstRow.getBoundingClientRect();
    if (rect.top < 80 || rect.bottom > (window.innerHeight || 0) - 80) {
      try { firstRow.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      catch (err) { firstRow.scrollIntoView(); }
    }
    var firstBtn = firstRow.querySelector('[data-option-value-btn], [data-fp-option-value-btn]');
    if (firstBtn) {
      try { firstBtn.focus({ preventScroll: true }); } catch (err) { firstBtn.focus(); }
    }
  }

  /* Add to cart: any form with [data-add-to-cart] or [data-fp-submit] submit button */
  qsa('.featured-product__form, .product-form, .carousel-quickshop__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[data-fp-submit], [data-add-to-cart]');
      var textEl = form.querySelector('[data-fp-submit-text], [data-add-text]');
      var originalText = textEl ? textEl.textContent : null;

      /* The button is aria-disabled rather than disabled while no colour is
         chosen, precisely so this runs: a truly disabled button dispatches no
         click and no submit, so pressing it could never be answered. Pressing
         it now points at the step that is missing instead of doing nothing. */
      if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') {
        nudgeMissingOptions(form);
        return;
      }
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      if (textEl) textEl.textContent = 'Adding…';

      var formData = new FormData(form);
      var payload = {};
      formData.forEach(function (value, key) { payload[key] = value; });
      payload.sections = 'cart-drawer';

      /* A pair is two units in one request: one line of two when the
         linings match, two lines of one when they do not. The discount
         itself is applied by checkout, not here. */
      var bundleEl = form.querySelector('[data-product-bundle]');
      var isPair = !!bundleEl && bundleEl.getAttribute('data-bundle-mode') === 'pair';
      if (isPair) {
        var firstId = Number(payload.id);
        var secondBtn = bundleEl.querySelector('[data-bundle-second-variant][aria-checked="true"]');
        var secondId = secondBtn ? Number(secondBtn.getAttribute('data-bundle-second-variant')) : firstId;
        payload = {
          items: firstId === secondId
            ? [{ id: firstId, quantity: 2 }]
            : [{ id: firstId, quantity: 1 }, { id: secondId, quantity: 1 }],
          sections: 'cart-drawer'
        };
      }

      postCart(routes.cartAddUrl || '/cart/add.js', payload)
        .then(function (data) {
          if (data.status) {
            if (textEl) textEl.textContent = originalText;
            if (submitBtn) submitBtn.removeAttribute('disabled');
            alert(data.description || 'This item could not be added to your bag.');
            return;
          }
          stampCart({ 'Entry': form.hasAttribute('data-hl-form') ? 'Add to bag (holiday page)'
            : form.classList.contains('carousel-quickshop__form') ? 'Add to bag (quick shop)'
            : form.classList.contains('featured-product__form') ? 'Add to bag (featured product)'
            : isPair ? 'Add to bag (pair)'
            : 'Add to bag (product page)' });
          renderCartDrawer(data.sections);
          fetchCartAndRender();
          /* Goes through the real close, not the class, so the focus trap
             is released. Taking the attributes off by hand left the trap's
             keydown listener attached to an overlay that was no longer
             there, which would pin Tab inside a closed element. */
          var openQuickshopEl = document.querySelector('.carousel-quickshop.is-open');
          if (openQuickshopEl) {
            if (window.SOLQuickshop && window.SOLQuickshop.close) {
              window.SOLQuickshop.close();
            } else {
              openQuickshopEl.classList.remove('is-open');
              openQuickshopEl.setAttribute('aria-hidden', 'true');
              var qsVideo = openQuickshopEl.querySelector('video');
              if (qsVideo) qsVideo.pause();
            }
          }
          /* Restored BEFORE the drawer opens, not after: the button is the
             element focus returns to on close, and a disabled button cannot
             take focus. Re-enabling afterwards left the drawer holding a
             reference to something unfocusable. */
          if (textEl) textEl.textContent = originalText;
          if (submitBtn) submitBtn.removeAttribute('disabled');
          openCartDrawer(submitBtn);
        })
        .catch(function () {
          if (textEl) textEl.textContent = originalText;
          if (submitBtn) submitBtn.removeAttribute('disabled');
        });
    });
  });

  /* Pair offer (snippets/pair-offer): "Often bought as a pair". Three
     fixed pairs, each two cases at the pair's price, independent of the
     colour picker. Pick one: ticking a pair unticks the others, and the
     button adds the ticked pair.
     preorder.js puts the ship line on each case as it goes in. */
  qsa('[data-pair-offer]').forEach(function (offer) {
    var rows = qsa('[data-pair-row]', offer);
    var addBtn = offer.querySelector('[data-pair-add]');
    var addText = offer.querySelector('[data-pair-add-text]');
    var money = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); };
    var ticked = function () { return rows.filter(function (r) { return r.checked; }); };
    function paintButton() {
      var on = ticked();
      var total = on.reduce(function (sum, r) { return sum + Number(r.getAttribute('data-price')); }, 0);
      addBtn.disabled = !on.length;
      addText.textContent = !on.length ? 'Tick a pair to add it'
        : (on.length === 1 ? 'Add the pair · ' : 'Add ' + on.length + ' pairs · ') + money(total);
    }
    /* A browser can restore the boxes on back/reload; start from the
       owner's default instead: Black + Red ticked, the others not. */
    rows.forEach(function (r, i) {
      r.checked = i === 0;
      r.addEventListener('change', function () {
        if (r.checked) rows.forEach(function (o) { if (o !== r) o.checked = false; });
        paintButton();
      });
    });
    paintButton();
    addBtn.addEventListener('click', function () {
      var on = ticked();
      if (addBtn.disabled || !on.length) return;
      var qty = {};
      on.forEach(function (r) {
        r.getAttribute('data-ids').split(',').forEach(function (id) { qty[id] = (qty[id] || 0) + 1; });
      });
      var items = Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id] }; });
      var label = addText.textContent;
      addBtn.disabled = true;
      addText.textContent = 'Adding…';
      postCart(routes.cartAddUrl || '/cart/add.js', { items: items, sections: 'cart-drawer' })
        .then(function (data) {
          addText.textContent = label;
          addBtn.disabled = false;
          if (data.status) { alert(data.description || 'These could not be added to your bag.'); return; }
          stampCart({ 'Entry': 'Add to bag (pair offer)' });
          renderCartDrawer(data.sections);
          fetchCartAndRender();
          openCartDrawer(addBtn);
        })
        .catch(function () { addText.textContent = label; addBtn.disabled = false; });
    });
  });

  /* Cart line quantity + remove (delegated, inside drawer body which re-renders) */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-cart-qty-minus]');
    var plus = e.target.closest('[data-cart-qty-plus]');
    var remove = e.target.closest('[data-cart-remove]');
    if (minus || plus) {
      var btn = minus || plus;
      var line = btn.getAttribute('data-line');
      var input = qs('[data-cart-qty-input][data-line="' + line + '"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val = minus ? Math.max(0, val - 1) : val + 1;
      input.value = val;
      changeCartLine(line, val);
    }
    if (remove) {
      changeCartLine(remove.getAttribute('data-line'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-qty-input]')) {
      var val = Math.max(0, parseInt(e.target.value, 10) || 0);
      changeCartLine(e.target.getAttribute('data-line'), val);
    }
  });

  var changeCartLine = debounce(function (line, quantity) {
    postCart(routes.cartChangeUrl || '/cart/change.js', { line: line, quantity: quantity, sections: 'cart-drawer' })
      .then(function (data) {
        renderCartDrawer(data.sections);
        updateCartCount(data.item_count);
        cartState = data;
      });
  }, 250);

  /* ---------------- Second case, on the way out of the drawer ----------------
     Offered once a session, on the click that leaves the drawer for the bag
     or for checkout, and only where the offer can be true: a bag holding
     exactly one case, one of it. Two already there and it is noise; two
     different lines and "add one more" has no referent. It stands down when
     the order limit is one, where the button would be a dead end.

     Dismissing is not declining. Escape and the backdrop put the shopper
     back in the drawer; both buttons carry on to wherever the click was
     going. Nothing here can strand anyone between the bag and the checkout,
     including a failed add: if the quantity change errors, it navigates
     anyway rather than swallowing the click. */
  var cartUpsell = qs('[data-cart-upsell]');
  if (cartUpsell) {
    /* The cart has to be known before the click, not after it.
       fetchCartAndRender only ran on a successful add to cart, so cartState
       was null on every fresh page load and the offer silently declined to
       fire: it could only ever appear in the same pageview as the add. Reload
       the page, come back tomorrow, arrive from anywhere at all, and the
       dialog was never shown. The guard that made a missing cart behave like
       an ordinary link turned that into silence rather than an error, which
       is why it took a live run to find.

       One request, and only where the dialog is actually rendered. */
    fetchCartAndRender();
    var upsellContinue = null;
    var releaseUpsellFocus = null;
    /* Asked once per CART, not once per session.

       Keyed to what is in the bag rather than to a bare flag, so a shopper
       who declines and then changes their mind about the bag itself gets
       asked again: a different cart is a different question. Declining and
       leaving the bag alone holds, which is the case that matters - that is
       a no, and it should stay a no.

       Accepting suppresses itself without any of this, because the bag then
       holds two and two does not qualify.

       ?second-case on any URL clears it, which is the only practical way to
       look at this thing twice while working on it. */
    var upsellKey = function () {
      if (!cartState || !cartState.items || !cartState.items.length) return '';
      var first = cartState.items[0];
      return 'sol:second-case:' + first.variant_id + ':' + cartState.item_count;
    };
    try {
      if (/[?&]second-case\b/.test(window.location.search)) {
        for (var si = sessionStorage.length - 1; si >= 0; si--) {
          var k = sessionStorage.key(si);
          if (k && k.indexOf('sol:second-case') === 0) sessionStorage.removeItem(k);
        }
      }
    } catch (e) {}
    var upsellSeen = function () {
      try { return sessionStorage.getItem(upsellKey()) === '1'; } catch (e) { return false; }
    };
    var markUpsellSeen = function () {
      try { sessionStorage.setItem(upsellKey(), '1'); } catch (e) {}
    };
    var upsellQualifies = function () {
      if (upsellSeen()) return false;
      if (!cartState || !cartState.items || cartState.items.length !== 1) return false;
      if (cartState.items[0].quantity !== 1) return false;
      var max = parseInt(cartUpsell.getAttribute('data-max-units'), 10);
      if (max > 0 && max < 2) return false;
      return true;
    };
    var closeUpsell = function () {
      cartUpsell.hidden = true;
      cartUpsell.classList.remove('is-open');
      if (releaseUpsellFocus) { releaseUpsellFocus(); releaseUpsellFocus = null; }
    };
    /* What happens after the shopper answers. A continuation rather than a
       url, because the three places that open this dialog finish in three
       different ways: a drawer link navigates, the cart page's checkout
       button has to be re-clicked so its own name=checkout goes with the
       form, and the drawer's close button simply closes the drawer. */
    var leaveUpsell = function () {
      var go = upsellContinue;
      upsellContinue = null;
      closeUpsell();
      if (go) go();
    };
    /* ---- which lining the second case gets ----
       Pre-selected to what is already in the bag. Picking the other one
       makes this a second LINE rather than a quantity bump, because a
       different lining is a different variant; the per-box shipping bands
       already price each case as its own parcel, so nothing downstream
       cares which of the two it is. */
    var upsellPicker = cartUpsell.querySelector('[data-cart-upsell-picker]');
    var upsellSwatches = qsa('.cart-upsell__swatch', cartUpsell);
    var upsellChosen = null;
    var chooseUpsellVariant = function (btn, focusIt) {
      if (!btn) return;
      upsellChosen = btn;
      upsellSwatches.forEach(function (s) {
        var on = s === btn;
        s.setAttribute('aria-checked', on ? 'true' : 'false');
        s.classList.toggle('is-chosen', on);
        /* Roving tabindex: a radio group is one tab stop, and the arrows
           move within it. */
        s.setAttribute('tabindex', on ? '0' : '-1');
      });
      var nameEl = cartUpsell.querySelector('[data-cart-upsell-pick-name]');
      if (nameEl) {
        nameEl.textContent = btn.getAttribute('data-upsell-name') || '';
        alignPickName(btn, nameEl);
      }
      /* Priced the way checkout prices the Buy X Get Y: the percentage
         comes off the LOWER-PRICED of the two cases, whichever was added
         second. What the button shows is what this case adds to the
         order, with its list price struck when that is less. */
      var listPrice = Number(btn.getAttribute('data-upsell-price')) || 0;
      var pct = parseFloat(cartUpsell.getAttribute('data-upsell-percent')) || 0;
      var inBagLine = cartState && cartState.items && cartState.items[0];
      var inBagPrice = inBagLine ? Number(inBagLine.original_price || inBagLine.price) || listPrice : listPrice;
      var off = pct > 0 ? Math.round(Math.min(inBagPrice, listPrice) * pct / 100) : 0;
      /* When the case being added is the dearer one, the saving lands on
         the case already in the bag, so this one is charged in full and
         the button says so; a short line under it says where the money
         came off instead of striking a price that was never cut. */
      var ownOff = listPrice <= inBagPrice ? off : 0;
      var priceEl = cartUpsell.querySelector('[data-cart-upsell-price]');
      if (priceEl) priceEl.textContent = formatMoney(listPrice - ownOff);
      var wasEl = cartUpsell.querySelector('[data-cart-upsell-was]');
      if (wasEl) wasEl.textContent = ownOff > 0 ? formatMoney(listPrice) : '';
      var shiftEl = cartUpsell.querySelector('[data-cart-upsell-shift]');
      if (shiftEl) {
        var shifted = off > 0 && ownOff === 0;
        var inBagName = inBagLine && inBagLine.variant_options ? String(inBagLine.variant_options[inBagLine.variant_options.length - 1] || '').replace(/ Interior$/, '') : '';
        shiftEl.hidden = !shifted;
        shiftEl.textContent = shifted ? formatMoney(off) + ' comes off your ' + (inBagName ? inBagName + ' ' : '') + 'case, the lower-priced of the two.' : '';
      }
      if (focusIt) { try { btn.focus(); } catch (e) {} }
    };

    /* Slide the lining's name so its centre meets the chosen swatch's,
       clamped so a long one cannot push past the panel's padding. With the
       two swatches spread apart, a name centred on the pair pointed at
       neither of them.

       Every measurement here is layout, never the label's rendered rect.
       The label animates between positions, so reading its own box gives a
       value part way through that transition and the offset ends up stale
       by one click: it aligns to where the label is travelling from.
       offsetWidth ignores transforms, and the label is centred in the
       content box, so its untransformed centre IS that box's centre. */
    function alignPickName(btn, nameEl) {
      var content = nameEl.parentElement;
      if (!content || !btn) return;
      var cs = window.getComputedStyle(content);
      var cRect = content.getBoundingClientRect();
      var sRect = btn.getBoundingClientRect();
      if (!cRect.width || !sRect.width) return;   /* dialog still hidden */
      var inner = cRect.width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var want = (sRect.left + sRect.width / 2) - (cRect.left + cRect.width / 2);
      var room = Math.max(0, (inner - nameEl.offsetWidth) / 2);
      var off = Math.max(-room, Math.min(room, want));
      nameEl.style.transform = 'translateX(' + off.toFixed(1) + 'px)';
    }

    /* The dialog is display:none until it opens, so every rect above reads
       zero on first paint. Re-run once it is actually on screen, and on
       resize, where the panel width and therefore the offset both change. */
    function realignPickName() {
      var nameEl = cartUpsell.querySelector('[data-cart-upsell-pick-name]');
      if (nameEl && upsellChosen) alignPickName(upsellChosen, nameEl);
    }
    window.addEventListener('resize', realignPickName);
    if (upsellPicker) {
      upsellPicker.addEventListener('click', function (e) {
        var btn = e.target.closest('.cart-upsell__swatch');
        if (btn) chooseUpsellVariant(btn, false);
      });
      upsellPicker.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        var i = upsellSwatches.indexOf(upsellChosen);
        if (i === -1) i = 0;
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        chooseUpsellVariant(upsellSwatches[(i + step + upsellSwatches.length) % upsellSwatches.length], true);
      });
    }

    var openUpsell = function (onContinue, opener) {
      upsellContinue = onContinue;
      markUpsellSeen();
      stampCart({ 'Second case offer': 'Shown' });
      var inBag = String(cartState.items[0].variant_id);
      var match = upsellSwatches.filter(function (s) {
        return s.getAttribute('data-upsell-variant') === inBag;
      })[0];
      chooseUpsellVariant(match || upsellSwatches[0], false);
      /* No picker on the page (one variant, or the product is gone): the
         price still has to say something, and the only honest figure is
         what the line in the bag costs. */
      if (!upsellSwatches.length) {
        var priceEl = cartUpsell.querySelector('[data-cart-upsell-price]');
        if (priceEl) priceEl.textContent = formatMoney(cartState.items[0].final_price);
      }
      cartUpsell.hidden = false;
      cartUpsell.classList.add('is-open');
      /* Both of these ran inside a requestAnimationFrame, and neither can
         afford to. Browsers suspend rAF entirely in a backgrounded tab and
         throttle it hard under low power, so a starved frame left this
         dialog with NO focus trap and the lining's name sitting at offset
         zero, centred on the pair and pointing at neither swatch.

         Neither needs the wait. The class above is what flips the panel off
         display:none, so by this line it is laid out, and reading a rect
         here forces layout synchronously and returns real numbers. The
         deferral existed because chooseUpsellVariant had already run while
         the panel was still hidden, where every rect reads zero; the answer
         to that is to measure again now, not to measure later.

         The rAF is kept as a second pass only, for the case where layout is
         not final on the first, and it is now harmless if it never runs. */
      releaseUpsellFocus = trapFocus(cartUpsell.querySelector('.cart-upsell__panel'), opener);
      realignPickName();
      requestAnimationFrame(realignPickName);
    };

    /* The one way in. Returns true when it has taken the click, so a caller
       knows to hold off doing whatever it was going to do. */
    offerSecondCase = function (opener, onContinue) {
      if (!upsellQualifies()) return false;
      openUpsell(onContinue, opener);
      return true;
    };

    document.addEventListener('click', function (e) {
      var leaving = e.target.closest && e.target.closest('[data-cart-continue]');
      if (leaving) {
        var href = leaving.getAttribute('href');
        if (offerSecondCase(leaving, function () { window.location.href = href; })) e.preventDefault();
        return;
      }
      /* The cart page's checkout button, which is a form submit rather than
         a link: the route most desktop shoppers take and the one this offer
         never saw. Re-clicking it afterwards rather than submitting the form
         by hand, because name="checkout" only travels with a real click on
         that button and the form needs it to go to checkout rather than
         merely update itself. */
      var cartCheckout = e.target.closest && e.target.closest('[data-cart-checkout]');
      if (cartCheckout) {
        if (cartCheckout.dataset.secondCaseAsked === '1') return;
        if (offerSecondCase(cartCheckout, function () {
          cartCheckout.dataset.secondCaseAsked = '1';
          cartCheckout.click();
        })) e.preventDefault();
        return;
      }
      if (!cartUpsell.classList.contains('is-open')) return;
      if (e.target.closest('[data-cart-upsell-dismiss]')) { stampCart({ 'Second case offer': 'Closed' }); closeUpsell(); return; }
      if (e.target.closest('[data-cart-upsell-skip]')) { stampThen({ 'Second case offer': 'Declined' }, leaveUpsell); return; }
      var add = e.target.closest('[data-cart-upsell-add]');
      if (add) {
        if (add.disabled) return;
        add.disabled = true;
        var chosenId = upsellChosen && upsellChosen.getAttribute('data-upsell-variant');
        var inBagId = String(cartState.items[0].variant_id);
        var req;
        if (chosenId && chosenId !== inBagId) {
          /* A different lining is a different variant, so it joins the bag
             as its own line rather than doubling the one already there. */
          req = postCart(routes.cartAddUrl || '/cart/add.js', { items: [{ id: Number(chosenId), quantity: 1 }], sections: 'cart-drawer' });
        } else {
          req = postCart(routes.cartChangeUrl || '/cart/change.js', { id: cartState.items[0].key, quantity: 2, sections: 'cart-drawer' });
        }
        /* The bag has to show what was just added. When the dialog came off
           the drawer's close button there is no navigation to repaint the
           page, so without this the badge and the drawer kept reading one
           case while the cart held two, and the shopper met the second one
           for the first time on the checkout total. */
        req.then(function (data) {
          if (data && data.sections) renderCartDrawer(data.sections);
          fetchCartAndRender();
          stampThen({ 'Second case offer': 'Added' }, leaveUpsell);
        }).catch(leaveUpsell);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartUpsell.classList.contains('is-open')) closeUpsell();
    });
  }


  /* ---------------- Holiday overlay ----------------
     An interruption on a browse, as opposed to the second-case dialog,
     which is an exit interception. Everything about its look is borrowed
     from that dialog on purpose; what differs is when it fires and what it
     does on confirm.

     Fires once the visitor has scrolled past `holiday_overlay_scroll`
     percent of the page, so it lands on somebody who has already looked at
     something rather than on the doorstep. Once per
     session. Add ?holiday to any URL to clear the flag when testing, or it
     looks broken on the second load. */
  var holiday = qs('[data-holiday-overlay]');
  if (holiday) {
    var holPanel    = holiday.querySelector('.holiday-overlay__panel');
    var holPicker   = holiday.querySelector('[data-holiday-picker]');
    var holSwatches = holPicker ? [].slice.call(holPicker.querySelectorAll('.holiday-overlay__swatch')) : [];
    var holNameEl   = holiday.querySelector('[data-holiday-pick-name]');
    /* NOT [data-holiday-price]: every swatch carries that attribute too, so
       querySelector matched the first SWATCH and writing the figure into it
       wiped out its badge and its colour dot. */
    var holPriceEl  = holiday.querySelector('[data-holiday-addprice]');
    var holCtaEl    = holiday.querySelector('[data-holiday-cta-label]');
    var holCtaText  = holCtaEl ? holCtaEl.textContent : '';
    var holVideo    = holiday.querySelector('video');
    var holChosen   = null;
    var holReleaseFocus = null;

    var HOL_KEY = 'sol:holiday-overlay';
    try {
      if (/[?&]holiday\b/.test(window.location.search)) sessionStorage.removeItem(HOL_KEY);
    } catch (e) {}
    function holSeen() {
      try { return sessionStorage.getItem(HOL_KEY) === '1'; } catch (e) { return false; }
    }
    function holMarkSeen() {
      try { sessionStorage.setItem(HOL_KEY, '1'); } catch (e) {}
    }

    /* Computed from LAYOUT, never from the label's own rect: the transform
       below runs for 180ms, so measuring the element mid-flight returns the
       previous position and the label ends up one click stale. */
    function alignHolidayPickName(btn) {
      if (!holNameEl || !btn) return;
      var content = holNameEl.parentElement;
      if (!content) return;
      var cs = window.getComputedStyle(content);
      var cRect = content.getBoundingClientRect();
      var sRect = btn.getBoundingClientRect();
      if (!cRect.width || !sRect.width) return;   /* still hidden */
      var inner = cRect.width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var want = (sRect.left + sRect.width / 2) - (cRect.left + cRect.width / 2);
      var room = Math.max(0, (inner - holNameEl.offsetWidth) / 2);
      var off = Math.max(-room, Math.min(room, want));
      holNameEl.style.transform = 'translateX(' + off.toFixed(1) + 'px)';
    }
    function realignHolidayPickName() {
      if (holChosen) alignHolidayPickName(holChosen);
    }
    window.addEventListener('resize', realignHolidayPickName);

    function chooseHolidayVariant(btn, focus) {
      if (!btn) return;
      holChosen = btn;
      holSwatches.forEach(function (s) {
        var on = s === btn;
        s.classList.toggle('is-chosen', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
        s.tabIndex = on ? 0 : -1;
      });
      /* A preorder colour says when it ships, here and on the button. */
      var holPre = btn.getAttribute('data-holiday-preorder');
      if (holNameEl) holNameEl.textContent = btn.getAttribute('data-holiday-name') + (holPre ? ' · ' + holPre : '');
      if (holCtaEl) holCtaEl.textContent = holPre ? 'Preorder' : holCtaText;
      if (holPriceEl) holPriceEl.textContent = formatMoney(Number(btn.getAttribute('data-holiday-price')));
      /* Synchronously, because reading offsetWidth forces layout and the
         panel is on screen by the time anything is clicked. The rAF is only
         a follow-up for the first placement while the panel is still
         hidden: browsers suspend rAF entirely in a background tab, so a
         deferred-only call can never run and the label stays stuck under
         the wrong swatch. */
      alignHolidayPickName(btn);
      requestAnimationFrame(function () { alignHolidayPickName(btn); });
      if (focus) btn.focus();
    }

    if (holPicker) {
      holPicker.addEventListener('click', function (e) {
        var btn = e.target.closest('.holiday-overlay__swatch');
        if (btn) chooseHolidayVariant(btn, false);
      });
      holPicker.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        var i = holSwatches.indexOf(holChosen);
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        chooseHolidayVariant(holSwatches[(i + d + holSwatches.length) % holSwatches.length], true);
      });
    }

    function openHoliday() {
      if (holSeen()) return;
      holMarkSeen();
      /* Whichever route got here, the other one stands down. */
      disarmHoliday();
      holiday.hidden = false;
      holiday.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      /* Both synchronously. The cart drawer defers its trapFocus a frame
         because its body is re-rendered by the add and focusing a node about
         to be replaced loses the focus; nothing here is re-rendered, and a
         background tab suspends rAF entirely, which would open this dialog
         with no focus trap at all. The rAF below is only a second pass at the
         label, for the case where layout was not final on the first. */
      realignHolidayPickName();
      holReleaseFocus = trapFocus(holiday, holiday.querySelector('[data-holiday-add]'));
      requestAnimationFrame(realignHolidayPickName);
      startHolidayWeather();
    }
    function closeHoliday() {
      holiday.classList.remove('is-open');
      holiday.hidden = true;
      document.documentElement.style.overflow = '';
      if (holReleaseFocus) { holReleaseFocus(); holReleaseFocus = null; }
      if (holVideo) holVideo.pause();
      stopHolidayWeather();
    }

    /* One way in: the visitor scrolls. There used to be a timer as well,
       removed by the owner's call on 2026-10-15: it treated time on page as
       interest, so it fired on someone who had opened the tab and walked
       away as readily as on someone reading. openHoliday holds the once-per-
       session flag. */
    function armHoliday() {
      if (holSeen()) return;
      armHolidayScroll();
    }
    function disarmHoliday() {
      window.removeEventListener('scroll', onHolidayScroll);
    }

    /* Percent of the SCROLLABLE distance, not of the viewport. On a page
       shorter than the window there is nothing to scroll, so scrollable is 0
       and this never fires, so short pages never show the overlay. Reading
       scrollHeight on every scroll event would thrash layout, so the measure
       is taken once per frame at most via the flag below. */
    function holidayScrollPct() {
      var doc = document.documentElement;
      var scrollable = (doc.scrollHeight || 0) - window.innerHeight;
      if (scrollable <= 0) return 0;
      var y = window.pageYOffset || doc.scrollTop || 0;
      return (y / scrollable) * 100;
    }
    var holScrollQueued = false;
    function onHolidayScroll() {
      if (holScrollQueued) return;
      holScrollQueued = true;
      /* setTimeout rather than rAF: a scroll happens in a visible tab, but
         this file has already been bitten twice by work that only ran inside
         a frame, and nothing here needs to be frame-accurate. */
      setTimeout(function () {
        holScrollQueued = false;
        if (holSeen()) { disarmHoliday(); return; }
        var want = parseFloat(holiday.getAttribute('data-scroll'));
        if (!(want > 0)) return;
        if (holidayScrollPct() >= want) { disarmHoliday(); openHoliday(); }
      }, 60);
    }
    function armHolidayScroll() {
      var want = parseFloat(holiday.getAttribute('data-scroll'));
      if (!(want > 0)) return;
      window.addEventListener('scroll', onHolidayScroll, { passive: true });
      /* Restored mid-page by a back button, or landed on an anchor: the
         threshold is already met and no scroll event is coming. */
      onHolidayScroll();
    }

    /* Stood down if the tab goes to the background and NOT re-armed when it
       comes back. Somebody who tabbed away for two minutes should not be met
       with this the moment they return. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) disarmHoliday();
    });

    holiday.addEventListener('click', function (e) {
      if (!holiday.classList.contains('is-open')) return;
      if (e.target.closest('[data-holiday-dismiss]')) { closeHoliday(); return; }
      var add = e.target.closest('[data-holiday-add]');
      if (!add || add.disabled) return;
      var id = holChosen && holChosen.getAttribute('data-holiday-variant');
      if (!id) return;
      add.disabled = true;
      postCart(routes.cartAddUrl || '/cart/add.js', {
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer'
      })
        .then(function (data) {
          if (data && data.status) {
            add.disabled = false;
            alert((data && data.description) || 'This item could not be added to your bag.');
            return;
          }
          if (data && data.sections) renderCartDrawer(data.sections);
          fetchCartAndRender();
          /* Closed before the drawer opens, so the overflow lock and the
             focus trap are both released by the one that set them. Opening
             the drawer on top of a live trap pins Tab inside a panel that is
             no longer the thing on screen. */
          closeHoliday();
          openCartDrawer(null);
        })
        .catch(function () { add.disabled = false; });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && holiday.classList.contains('is-open')) closeHoliday();
    });

    /* ---- weather: snow, and only snow ----
       One canvas, one particle system, one loop. Depth-layered so far flakes
       are small, dim and slow and near ones are larger, brighter and faster,
       which is what stops it reading as a screensaver. Run at the full count:
       the owner asked for heavy snow and no confetti, and a thick drift suits
       a holiday panel better than a burst that is gone in three seconds.

       It is decoration: under prefers-reduced-motion none of it runs and the
       panel is unchanged. */
    var holCanvas = holiday.querySelector('[data-holiday-weather]');
    var holCtx = holCanvas ? holCanvas.getContext('2d') : null;
    var HOL_SNOW_MAX = 200;
    var holSnow = [], holRaf = null, holLast = 0, holW = 0, holH = 0;
    var holReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function holSize() {
      if (!holCanvas) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var r = holiday.getBoundingClientRect();
      var prevW = holW;
      holW = r.width; holH = r.height;
      /* Rescale flakes already in flight. Without this a resize leaves them
         inside the OLD width, bunched against the left edge, while only the
         newly added ones use the full span. */
      if (prevW > 0 && holW > 0 && prevW !== holW) {
        var k = holW / prevW;
        for (var i = 0; i < holSnow.length; i++) holSnow[i].x *= k;
      }
      holCanvas.width = Math.round(holW * dpr);
      holCanvas.height = Math.round(holH * dpr);
      holCanvas.style.width = holW + 'px';
      holCanvas.style.height = holH + 'px';
      holCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function holFlake(seed) {
      var d = Math.random();
      return {
        x: Math.random() * holW,
        y: seed ? Math.random() * holH : -8 - Math.random() * 40,
        r: 0.7 + d * 2.1, vy: 10 + d * 26,
        amp: 6 + Math.random() * 20, freq: 0.25 + Math.random() * 0.5,
        ph: Math.random() * Math.PI * 2, a: 0.16 + d * 0.5
      };
    }
    function holFrame(t) {
      if (!holLast) holLast = t;
      var dt = Math.min((t - holLast) / 1000, 0.05);   /* clamp after a tab switch */
      holLast = t;
      holCtx.clearRect(0, 0, holW, holH);
      for (var i = 0; i < holSnow.length; i++) {
        var f = holSnow[i];
        f.y += f.vy * dt; f.ph += f.freq * dt;
        var x = f.x + Math.sin(f.ph) * f.amp;
        if (f.y - f.r > holH) { holSnow[i] = holFlake(false); continue; }
        holCtx.globalAlpha = f.a; holCtx.fillStyle = '#fff';
        holCtx.beginPath(); holCtx.arc(x, f.y, f.r, 0, 6.2832); holCtx.fill();
      }
      holCtx.globalAlpha = 1;
      holRaf = requestAnimationFrame(holFrame);
    }
    function startHolidayWeather() {
      if (holReduce || !holCtx) return;
      holSize();
      /* The full count. 'Max snow', per the owner. */
      while (holSnow.length < HOL_SNOW_MAX) holSnow.push(holFlake(true));
      if (!holRaf) { holLast = 0; holRaf = requestAnimationFrame(holFrame); }
    }
    function stopHolidayWeather() {
      if (holRaf) { cancelAnimationFrame(holRaf); holRaf = null; }
    }
    window.addEventListener('resize', function () {
      if (holiday.classList.contains('is-open')) holSize();
    });

    if (holSwatches.length) chooseHolidayVariant(holSwatches[0], false);
    armHoliday();
  }

  /* ---------------- Quantity steppers (product forms) ---------------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.quantity-selector');
    if (!wrap) return;
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    /* The floor comes from the input's own min, which is what it is for.
       Hard-coding 1 here was right for the product page, where you cannot
       add zero of something, and wrong for the cart, where min="0" and
       there is no other remove control on the table - minus simply stopped
       at 1 and a line could not be taken out at all. */
    var qtyFloor = parseInt(input.getAttribute('min'), 10);
    if (isNaN(qtyFloor)) qtyFloor = 1;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = qtyFloor;
    val = minus ? Math.max(qtyFloor, val - 1) : val + 1;
    // Honour the input's own max. Without this the plus button walks past a
    // ceiling the markup declares, and the shopper only finds out at the
    // cart, after they thought they were done.
    var qtyMax = parseInt(input.getAttribute('max'), 10);
    if (qtyMax && val > qtyMax) val = qtyMax;
    input.value = val;
    syncCartPageLine(input);
  });

  /* ---------------- Cart page quantity ----------------
     The cart page uses the same [data-qty-*] stepper markup as the product
     page, and that stepper only ever writes a number into an input. On the
     product page that is the whole job, because nothing has been bought
     yet. On the cart page it meant the control changed the figure in the
     box and nothing else: the line total and the subtotal kept their
     server-rendered values, so three cases sat there reading $189, and the
     cart itself was not updated until the form was submitted. Someone could
     read $189, press checkout, and be charged $567.

     So a quantity change on a cart row now goes to the server and the two
     money figures are rewritten from what comes back, rather than from
     arithmetic done here. The name="updates[]" inputs still work for a
     no-JS submit, and applying the same quantity twice is idempotent.

     Keyed by line key rather than index: an index shifts the moment another
     line is removed and then refers to someone else's item. */
  /* One request per settled value, only the newest answer is believed, and
     an unreadable box is never treated as a number.

     Three bugs have lived in this function and each one cost money, so the
     reasoning is written down.

     ONE: a request per click. Press + three times and three go out for 2, 3
     and 4; the replies race and the last to land writes its own number into
     the box. Fixed by the debounce: a burst becomes one request for the
     number the shopper settled on.

     TWO: the reply writing its quantity back unconditionally. That write
     exists for a good reason - a quantity the server declines has to be
     shown honestly - but a late reply from a superseded request would undo
     input newer than itself. Fixed by the sequence number.

     THREE, and the worst: parseInt('') is NaN and NaN || 0 is 0, so
     emptying the box to type a new number sent quantity 0 and DELETED the
     line. Clearing a field before retyping it is the most ordinary thing a
     person does in a text box, and it was silently throwing the item out of
     the cart. readQty returns null for anything it cannot read and the sync
     does nothing at all with null; the box is put back to the real quantity
     when it loses focus.

     And the visible symptom all three shared: a line total left over from
     the old quantity sitting beside a subtotal for the new one. Whenever the
     line is no longer in the cart that comes back, the page reloads rather
     than repainting part of itself, because half-correct money is worse than
     a reload. */
  var cartSyncSeq = 0;
  function cartLineMax(input) {
    var m = parseInt(input.getAttribute('max'), 10);
    return (m && m > 0) ? m : 0;
  }
  function readQty(input) {
    var raw = String(input.value == null ? '' : input.value).trim();
    if (raw === '') return null;
    if (!/^\d+$/.test(raw)) return null;
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 0) return null;
    var max = cartLineMax(input);
    if (max && n > max) n = max;
    return n;
  }
  function syncCartPageLine(input) {
    var row = input.closest('[data-cart-row]');
    if (!row) return;
    var qty = readQty(input);
    /* Null means the box says nothing a quantity can be made of. Leave the
       cart exactly as it is and wait for a real value. */
    if (qty === null) return;
    if (String(qty) !== String(input.value)) input.value = qty;
    if (row.cartSyncTimer) clearTimeout(row.cartSyncTimer);
    row.classList.add('is-updating');
    row.cartSyncTimer = setTimeout(function () { commitCartPageLine(row, input, qty); }, 250);
  }
  function commitCartPageLine(row, input, qty) {
    var key = row.getAttribute('data-cart-key');
    var seq = ++cartSyncSeq;
    postCart(routes.cartChangeUrl || '/cart/change.js', { id: key, quantity: qty })
      .then(function (cart) {
        if (seq !== cartSyncSeq) return;
        row.classList.remove('is-updating');
        if (!cart || !cart.items) return;
        var line = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) { line = cart.items[i]; break; }
        }
        /* The line is gone: a deliberate 0, or stock, or something else
           entirely. Either way this page is now describing a cart that does
           not exist, and there is no partial repaint that makes it honest. */
        if (!line) { window.location.reload(); return; }
        /* The second-case discount is allocated per line, and Shopify
           re-splits and re-prices lines whenever a quantity changes which
           cases are paired. Repainting one row's total would leave struck
           prices and offer tags on the other rows describing the old split,
           so any change to the discount or to the number of lines is a
           reload. */
        var summary = qs('[data-cart-discount]');
        var renderedDiscount = summary ? parseInt(summary.getAttribute('data-cart-discount'), 10) || 0 : 0;
        if (cart.total_discount !== renderedDiscount || cart.items.length !== qsa('[data-cart-row]').length) {
          window.location.reload();
          return;
        }
        var lineTotal = row.querySelector('[data-cart-line-total]');
        if (lineTotal) lineTotal.textContent = formatMoney(line.final_line_price);
        if (String(line.quantity) !== String(input.value)) input.value = line.quantity;
        row.cartLastGoodQty = line.quantity;
        var subtotal = qs('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        updateCartCount(cart.item_count);
        cartState = cart;
        /* The checkout button and the order-limit notice are server-rendered
           and trade places when the bag crosses the limit. Repainting only
           the money left Checkout on screen at eight cases. Crossing that
           line either way is a reload, for the same reason as above. */
        var max = parseInt(window.theme && window.theme.maxOrderUnits, 10);
        if (max > 0 && (cart.item_count > max) === !!qs('[data-cart-checkout]')) {
          window.location.reload();
        }
      })
      .catch(function () {
        if (seq !== cartSyncSeq) return;
        row.classList.remove('is-updating');
      });
  }
  /* Seed each row's last known good quantity from what the server rendered,
     so the very first blur on an emptied box has something true to go back
     to rather than guessing at the first line in the cart. */
  qsa('[data-cart-row]').forEach(function (row) {
    var input = row.querySelector('[data-qty-input]');
    if (input) row.cartLastGoodQty = parseInt(input.value, 10) || 1;
  });
  /* Leaving the box empty is not an instruction, so when it loses focus it
     goes back to what is actually in the cart. */
  document.addEventListener('blur', function (e) {
    if (!e.target.matches || !e.target.matches('[data-qty-input]')) return;
    var row = e.target.closest('[data-cart-row]');
    if (!row) return;
    if (readQty(e.target) !== null) return;
    e.target.value = row.cartLastGoodQty || 1;
  }, true);

  /* Typing a quantity straight into the box has to do the same thing as
     pressing the buttons beside it. */
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-qty-input]')) syncCartPageLine(e.target);
  });

  /* ---------------- Variant selection (featured product + main product) ---------------- */
  function initVariantPicker(root) {
    var jsonEl = root.querySelector('[data-fp-product-json], [data-product-json]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var optionGroups = qsa('[data-fp-option-index], [data-option-index]', root);
    var variantIdInput = root.querySelector('[data-fp-variant-id], [data-variant-id]');
    var priceWrap = root.querySelector('[data-price-wrap]') || root.querySelector('.price');
    var submitBtn = root.querySelector('[data-fp-submit], [data-add-to-cart]');
    var submitTextEl = root.querySelector('[data-fp-submit-text], [data-add-text]');
    var priceInlineEls = qsa('[data-fp-price]', root).concat(qsa('[data-sticky-price]'));

    var selected = optionGroups.map(function (group) {
      var active = group.querySelector('.is-selected');
      /* Mirror whatever arrived selected, so the first render is right. */
      markPressed(group, active);
      return active ? active.getAttribute('data-value') : null;
    });

    function findMatch() {
      if (selected.some(function (val) { return val === null; })) return null;
      return variants.filter(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return opts[i] === val; });
      })[0];
    }

    var unselectedText = submitBtn && submitBtn.getAttribute('data-unselected-text');

    function setUnselectedState() {
      /* aria-disabled, NOT disabled: the button has to stay clickable so that
         pressing it can point at the unmade choice. The submit handler refuses
         the add and nudges instead. */
      if (submitBtn) {
        submitBtn.removeAttribute('disabled');
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('is-unselected');
      }
      if (submitTextEl && unselectedText) submitTextEl.textContent = unselectedText;
    }

    function updateUI(variant) {
      if (!variant) {
        setUnselectedState();
        try { root.dispatchEvent(new CustomEvent('sol:variant', { detail: null })); } catch (err) {}
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      priceInlineEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
      if (priceWrap) {
        var reg = priceWrap.querySelector('.price__regular');
        var cmp = priceWrap.querySelector('.price__compare');
        if (reg) reg.textContent = formatMoney(variant.price);
        if (cmp) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            cmp.textContent = formatMoney(variant.compare_at_price);
            cmp.style.display = '';
          } else {
            cmp.style.display = 'none';
          }
        }
      }
      if (submitBtn) {
        /* Sold out is a real dead end, so it gets a real disabled button.
           "Nothing picked yet" is not - that one stays pressable. */
        submitBtn.toggleAttribute('disabled', !variant.available);
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.classList.remove('is-unselected');
      }
      if (submitTextEl) {
        submitTextEl.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      /* The pair option, below, prices itself off whichever lining is
         live, so it listens here rather than reaching into this closure. */
      try { root.dispatchEvent(new CustomEvent('sol:variant', { detail: variant })); } catch (err) {}
      if (variant.featured_image) {
        var gallery = root.querySelector('[data-product-gallery]');
        if (gallery && gallery.setActiveGalleryMediaBySrc) {
          gallery.setActiveGalleryMediaBySrc(variant.featured_image.src);
        } else {
          var mainImg = document.querySelector('.product-gallery__slide.is-active img');
          if (mainImg && variant.featured_image.src) mainImg.src = variant.featured_image.src;
        }
      }
    }

    optionGroups.forEach(function (group, index) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fp-option-value-btn], [data-option-value-btn]');
        if (!btn || btn.disabled) return;
        qsa('.product-option__value', group).forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        markPressed(group, btn);
        var row = group.closest('.product-option');
        if (row) row.classList.remove('product-option--required', 'product-option--nudge');
        selected[index] = btn.getAttribute('data-value');
        var label = group.previousElementSibling;
        if (label) {
          var valueSpan = label.querySelector('[data-fp-option-value], [data-option-value]');
          if (valueSpan) valueSpan.textContent = shortOptionValue(selected[index]);
        }
        updateUI(findMatch());
      });
    });
  }

  qsa('.featured-product, .product-page, .carousel-quickshop').forEach(initVariantPicker);

  /* ---------------- The second case, as one line ----------------
     "Add a second case, 10% off it." The page only shows the price; the
     money comes off at checkout through an automatic Buy X Get Y
     discount, and Shopify puts that discount on the LOWER-PRICED of the
     two cases, whichever was added second. The pair is priced here the
     same way, so the total on the button is the total at checkout.

     The right-hand figure on the line is what the second case adds to
     the order: pair total less the first case. Same lining, that is the
     second case at the discount. Mixed, with the dearer one second, the
     saving lands on the cheaper one and a note under the picker says so.

     The second case's lining mirrors the first until the shopper touches
     it, then stays where they put it. Unticking hides the picker but
     keeps the choice. While the line is on, the quantity stepper steps
     aside: "2 x a pair" is a question nobody should be asked. */
  function initBundlePicker(root) {
    var bundle = root.querySelector('[data-product-bundle]');
    if (!bundle) return;
    var jsonEl = root.querySelector('[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    if (!variants.length) return;

    var pct = parseFloat(bundle.getAttribute('data-bundle-percent')) || 0;
    var toggle = bundle.querySelector('[data-bundle-toggle]');
    var second = bundle.querySelector('[data-bundle-second]');
    var secondBtns = qsa('[data-bundle-second-variant]', bundle);
    var secondName = bundle.querySelector('[data-bundle-second-name]');
    var secondPriceEl = bundle.querySelector('[data-bundle-second-price]');
    var secondWasEl = bundle.querySelector('[data-bundle-second-was]');
    var mixedNote = bundle.querySelector('[data-bundle-mixed-note]');
    var secondWasSr = bundle.querySelector('[data-bundle-second-was-sr]');
    var submitBtn = root.querySelector('[data-add-to-cart]');
    var submitTextEl = root.querySelector('[data-add-text]');
    var addPriceEl = root.querySelector('[data-add-price]');
    var qtyWrap = root.querySelector('.quantity-selector');
    var qtyInput = root.querySelector('[data-qty-input]');

    var first = null;
    var secondChosen = null;
    var secondTouched = false;

    /* The first available variant stands in before a lining is chosen, the
       same stand-in the price block at the top of the page uses. */
    var fallback = variants.filter(function (v) { return v.available; })[0] || variants[0];

    function isOn() { return bundle.getAttribute('data-bundle-mode') === 'pair'; }

    function pairMath() {
      var p1 = (first || fallback).price;
      var p2 = secondChosen ? Number(secondChosen.getAttribute('data-bundle-second-price')) : p1;
      /* Off the cheaper one, rounded to the cent the way checkout rounds. */
      var off = Math.round(Math.min(p1, p2) * pct / 100);
      var total = p1 + p2 - off;
      /* Where the money comes off matters for what the line may say. When
         the second case is the dearer one, Shopify takes the 10% off the
         FIRST case, so the second is charged its full listed price and the
         line must show that, with a note saying which case the saving
         landed on. Striking the second case's price there would tell the
         shopper the Red was discounted when it was the Black. */
      var secondOff = p2 <= p1 ? off : 0;
      return { total: total, second: p2 - secondOff, list: p2, off: off, secondOff: secondOff, mixedDearer: p2 > p1 };
    }
    function liningName(v) {
      return String((v && v.option2) || '').replace(/ Interior$/, '');
    }

    function chooseSecond(btn, focus) {
      if (!btn) return;
      secondChosen = btn;
      secondBtns.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (secondName) secondName.textContent = btn.getAttribute('data-bundle-second-value') || '';
      if (focus) btn.focus();
      paint();
    }

    function paint() {
      var m = pairMath();
      if (secondPriceEl) secondPriceEl.textContent = formatMoney(m.second);
      if (secondWasEl) secondWasEl.textContent = m.secondOff > 0 ? formatMoney(m.list) : '';
      if (secondWasSr) secondWasSr.hidden = !(m.secondOff > 0);
      if (mixedNote) {
        mixedNote.hidden = !m.mixedDearer;
        if (m.mixedDearer) {
          mixedNote.textContent = 'The ' + pct + '% (' + formatMoney(m.off) + ') comes off your ' +
            liningName(first || fallback) + ' case, the lower-priced of the two.';
        }
      }

      var on = isOn();
      if (toggle) toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      if (second) second.hidden = !on;
      if (qtyWrap) qtyWrap.hidden = on;
      if (on && qtyInput) qtyInput.value = 1;

      /* Only a variant that can be bought gets its button rewritten; the
         unselected and sold-out states belong to the variant picker. */
      var buyable = first && first.available;
      if (submitTextEl && buyable) submitTextEl.textContent = on ? 'Add the pair to cart' : 'Add to cart';
      if (addPriceEl) addPriceEl.textContent = (on && buyable) ? formatMoney(m.total) : '';
    }

    if (toggle) {
      var flip = function () {
        bundle.setAttribute('data-bundle-mode', isOn() ? 'one' : 'pair');
        paint();
      };
      toggle.addEventListener('click', function (e) {
        /* The "i" and its card sit inside the line; a press on either is
           not an answer to the question the line asks. */
        if (e.target.closest('[data-offer-terms], [data-offer-terms-open]')) return;
        flip();
      });
      /* A div with the checkbox role: Space and Enter are the keys a real
         checkbox answers to, and it has to answer to them too. */
      toggle.addEventListener('keydown', function (e) {
        if (e.target !== toggle) return;
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); flip(); }
      });
    }

    var secondGroup = bundle.querySelector('[data-bundle-second-values]');
    if (secondGroup) {
      secondGroup.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bundle-second-variant]');
        if (!btn) return;
        secondTouched = true;
        chooseSecond(btn, false);
      });
      /* Arrow keys walk a radiogroup; that is what makes it one. */
      secondGroup.addEventListener('keydown', function (e) {
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        secondTouched = true;
        var i = secondBtns.indexOf(secondChosen);
        chooseSecond(secondBtns[(i + step + secondBtns.length) % secondBtns.length], true);
      });
    }

    root.addEventListener('sol:variant', function (e) {
      first = e.detail || null;
      if (first && !secondTouched) {
        var match = secondBtns.filter(function (b) {
          return b.getAttribute('data-bundle-second-variant') === String(first.id);
        })[0];
        if (match) { chooseSecond(match, false); return; }
      }
      paint();
    });

    chooseSecond(secondBtns.filter(function (b) {
      return b.getAttribute('data-bundle-second-variant') === String(fallback.id);
    })[0] || secondBtns[0], false);
    paint();
  }
  qsa('.product-page').forEach(initBundlePicker);

  /* ---------------- "See details" and the terms overlay ----------------
     One overlay, opened from the product page line and from the
     second-case dialog. Escape and the backdrop close it; the keydown is
     taken in the capture phase and stopped so the dialog beneath does not
     close on the same press. Focus is trapped while it is open and goes
     back to the link that opened it. */
  (function () {
    var overlay = qs('[data-offer-terms-overlay]');
    if (!overlay) return;
    var release = null;
    var opener = null;
    function openTerms(btn) {
      opener = btn || null;
      overlay.hidden = false;
      overlay.classList.add('is-open');
      release = trapFocus(overlay.querySelector('.offer-terms-overlay__panel'), opener);
      var x = overlay.querySelector('.offer-terms-overlay__x');
      if (x) { try { x.focus(); } catch (err) {} }
    }
    function closeTerms() {
      if (!overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.hidden = true;
      if (release) { release(); release = null; }
      else if (opener) { try { opener.focus(); } catch (err) {} }
      opener = null;
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-offer-terms-open]');
      if (open) { e.preventDefault(); e.stopPropagation(); openTerms(open); return; }
      if (e.target.closest('[data-offer-terms-close]') && overlay.contains(e.target)) { e.preventDefault(); closeTerms(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !overlay.classList.contains('is-open')) return;
      e.stopPropagation();
      closeTerms();
    }, true);
  })();

  /* ---------------- Product gallery thumbnails + swipe ---------------- */
  qsa('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-product-gallery-main]');
    var thumbsWrap = gallery.querySelector('[data-product-gallery-thumbs]');
    var slides = qsa('.product-gallery__slide', main);
    var thumbs = qsa('.product-gallery__thumb', gallery);
    var dots = qsa('.product-gallery__dot', gallery);
    var isStrip = gallery.classList.contains('product-gallery--strip');

    /* Amazon-style dot pagination: never lay out one dot per photo. Show a
       window of at most DOT_WINDOW, centered on the active photo, and shrink
       the dot at whichever end still has more photos hidden past it - the
       same "there's more this way" hint iOS and Amazon both use. A window
       edge that IS the true first or last photo stays full size, since
       there's nothing further to hint at in that direction. */
    var DOT_WINDOW = 5;
    var updateDotWindow = function () {
      var total = dots.length;
      if (!total) return;
      var activeIndex = dots.findIndex(function (d) { return d.classList.contains('is-active'); });
      if (activeIndex === -1) activeIndex = 0;
      var start = total <= DOT_WINDOW ? 0 : Math.min(Math.max(activeIndex - 2, 0), total - DOT_WINDOW);
      var end = Math.min(start + DOT_WINDOW, total);
      dots.forEach(function (dot, i) {
        var hidden = i < start || i >= end;
        dot.classList.toggle('is-hidden', hidden);
        if (hidden) { dot.classList.remove('is-edge'); return; }
        var isEdge = (i === start && start > 0) || (i === end - 1 && end < total);
        dot.classList.toggle('is-edge', isEdge);
      });
    };

    var setActiveMedia = function (id) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === id); });
      dots.forEach(function (d) {
        var isActive = d.getAttribute('data-media-id') === id;
        d.classList.toggle('is-active', isActive);
        d.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      updateDotWindow();
      /* On the sideways strip, keep the active thumbnail in view when the
         photo changes by swipe or by a variant pick. Scrolls the strip
         itself, never the page. */
      if (isStrip && thumbsWrap) {
        var activeThumb = thumbs.find(function (t) { return t.getAttribute('data-media-id') === id; });
        if (activeThumb) {
          var left = activeThumb.offsetLeft; // the strip is position: relative, so this is already strip-relative
          if (left < thumbsWrap.scrollLeft || left + activeThumb.offsetWidth > thumbsWrap.scrollLeft + thumbsWrap.clientWidth) {
            thumbsWrap.scrollTo({ left: Math.max(0, left - 20), behavior: 'smooth' });
          }
        }
      }
      slides.forEach(function (slide) {
        var isActive = slide.getAttribute('data-media-id') === id;
        slide.classList.toggle('is-active', isActive);
        var video = slide.querySelector('video');
        if (video) {
          /* Arriving at a video slide starts it from the top, so landing on
             it twice shows the same thing both times rather than resuming
             halfway through whatever played last. Only videos the gallery
             marked autoplay do this; any other one still waits to be
             started by hand, and a video the viewer paused stays paused. */
          if (isActive) {
            if (video.hasAttribute('autoplay')) autoPlay(video, true);
          } else {
            autoPause(video);
          }
        }
      });
    };
    updateDotWindow();
    gallery.setActiveGalleryMedia = setActiveMedia;
    gallery.setActiveGalleryMediaBySrc = function (srcUrl) {
      if (!srcUrl) return;
      var filename = srcUrl.split('/').pop().split('?')[0];
      var match = thumbs.find(function (t) {
        var img = t.querySelector('img');
        var tFilename = img ? (img.src || '').split('/').pop().split('?')[0] : '';
        return tFilename === filename;
      });
      if (match) setActiveMedia(match.getAttribute('data-media-id'));
    };

    var stepActiveMedia = function (direction) {
      var currentIndex = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (currentIndex === -1) return;
      var nextIndex = (currentIndex + direction + slides.length) % slides.length;
      setActiveMedia(slides[nextIndex].getAttribute('data-media-id'));
    };

    qsa('[data-gallery-step]', main).forEach(function (btn) {
      btn.addEventListener('click', function () {
        stepActiveMedia(parseInt(btn.getAttribute('data-gallery-step'), 10));
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveMedia(thumb.getAttribute('data-media-id'));
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        setActiveMedia(dot.getAttribute('data-media-id'));
      });
    });

    /* The side rail is capped to the photo's height; the strip runs
       sideways and needs no cap. */
    if (thumbsWrap && !isStrip) {
      var capThumbsHeight = function () {
        if (window.innerWidth <= 749) {
          thumbsWrap.style.maxHeight = '';
          return;
        }
        thumbsWrap.style.maxHeight = main.getBoundingClientRect().height + 'px';
      };
      capThumbsHeight();
      window.addEventListener('resize', debounce(capThumbsHeight, 150));
    }

    /* Swipe left/right on the main image to move between photos on mobile */
    var touchStartX = 0;
    var touchStartY = 0;
    var touching = false;
    main.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touching = true;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (!touching) return;
      touching = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      stepActiveMedia(dx < 0 ? 1 : -1);
    }, { passive: true });
  });

  /* ---------------- Gallery video: the one control it has left ----------------
     The native control bar is off, so this button is the whole of the
     pause/stop mechanism WCAG 2.2.2 asks for on an autoplaying clip longer
     than five seconds. It swaps a single path between pause and play rather
     than toggling two icons, so there is no hidden element to go wrong.

     Pressing play clears the viewer-stopped flag through the existing play
     listener in trackManualPause, which is what lets a clip someone paused
     and then restarted by hand go back to behaving normally. */
  var ICON_PAUSE = 'M9 5h3v14H9zM14 5h3v14h-3z';
  var ICON_PLAY = 'M8 5.5v13l11-6.5-11-6.5z';
  qsa('[data-gallery-video-toggle]').forEach(function (btn) {
    /* Three places use this control now: the gallery slide, the second-case
       dialog and the holiday overlay. Each names the ancestor that holds both
       the button and the video it belongs to. The holiday overlay's toggle is
       a sibling of its media div rather than a child of it, so the panel is
       its scope; miss that and the lookup below finds no video and REMOVES
       the button, which is a silent disappearance rather than an error. */
    var scope = btn.closest('.product-gallery__slide, .cart-upsell__media, .holiday-overlay__panel');
    var video = scope && scope.querySelector('video');
    if (!video) { btn.parentNode && btn.parentNode.removeChild(btn); return; }
    /* This button is the video's control surface, so the native bar must not
       also be there. Liquid turns it off, and this holds the invariant if a
       controls: true ever creeps back into the snippet. */
    video.removeAttribute('controls');
    video.controls = false;
    var path = btn.querySelector('path');
    function syncToggle() {
      var playing = !video.paused && !video.ended;
      if (path) path.setAttribute('d', playing ? ICON_PAUSE : ICON_PLAY);
      btn.setAttribute('aria-label', playing ? 'Pause video' : (video.ended ? 'Replay video' : 'Play video'));
    }
    ['play', 'pause', 'ended'].forEach(function (evt) {
      video.addEventListener(evt, syncToggle);
    });
    btn.addEventListener('click', function () {
      if (video.paused || video.ended) {
        if (video.ended) video.currentTime = 0;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    });
    syncToggle();
  });

  /* ---------------- Feature card replay button (for one-shot autoplay videos) ---------------- */
  qsa('[data-replayable-video]').forEach(function (video) {
    var btn = video.parentElement.querySelector('[data-replay-video]');
    if (!btn) return;
    video.addEventListener('ended', function () { btn.hidden = false; });
    video.addEventListener('play', function () { btn.hidden = true; });
    btn.addEventListener('click', function () {
      video.currentTime = 0;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      btn.hidden = true;
    });
  });

  /* ---------------- Cycling word heading (timed, plays once, ends on last word) ---------------- */
  qsa('.video-feature__cycle-word').forEach(function (el) {
    var words = (el.getAttribute('data-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (words.length < 2) return;
    var lastIndex = words.length - 1;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = words[lastIndex];
      return;
    }

    var section = el.closest('.video-feature') || el;
    var currentIndex = 0;
    var timer = null;
    var started = false;

    var startCycle = function () {
      if (started) return;
      started = true;
      timer = setInterval(function () {
        currentIndex++;
        el.classList.add('is-swapping');
        setTimeout(function () {
          el.textContent = words[currentIndex];
          el.classList.remove('is-swapping');
        }, 180);
        if (currentIndex >= lastIndex) {
          clearInterval(timer);
          timer = null;
        }
      }, 1000);
    };

    if ('IntersectionObserver' in window) {
      var cycleObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startCycle();
            cycleObserver.disconnect();
          }
        });
      }, { threshold: 0.4 });
      cycleObserver.observe(section);
    } else {
      startCycle();
    }
  });

  /* ---------------- Carousel ---------------- */
  qsa('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var items = qsa('[data-carousel-item]', track);
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var dotsWrap = carousel.parentElement.querySelector('[data-carousel-dots]');
    if (!items.length) return;

    var dots = items.map(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'carousel__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      if (dotsWrap) dotsWrap.appendChild(dot);
      return dot;
    });

    function setActive(index) {
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActive(items.indexOf(entry.target));
          }
        });
      }, { root: track, threshold: 0.6 });
      items.forEach(function (item) { observer.observe(item); });
    }
    setActive(0);

    function scrollByCard(direction) {
      var card = items[0];
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      var delta = (card.getBoundingClientRect().width + gap) * direction;
      track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    /* Quick-shop overlay: click a card to view the media large + shop the product */
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        if (window.SOLQuickshop) window.SOLQuickshop.open(item.querySelector('video'));
      });
    });
  });

  /* ---------------- Global quick-shop overlay (any product photo/video, anywhere) ---------------- */
  (function () {
    var quickshop = qs('[data-carousel-quickshop]');
    if (!quickshop) return;
    var quickshopVideo = quickshop.querySelector('[data-carousel-quickshop-video]');
    var quickshopImage = quickshop.querySelector('[data-carousel-quickshop-image]');

    var releaseQuickshopFocus = null;
    var openQuickshop = function (mediaEl) {
      if (!mediaEl) return;
      if (mediaEl.tagName === 'VIDEO') {
        quickshopVideo.src = mediaEl.currentSrc || mediaEl.src || mediaEl.getAttribute('data-lazy-src');
        quickshopVideo.muted = true;
        quickshopVideo.currentTime = 0;
        applySlowRate(quickshopVideo);
        quickshopVideo.style.display = '';
        quickshopImage.style.display = 'none';
        quickshopVideo.play().catch(function () {});
      } else {
        // Guard the assignment: a null src stringifies to "null" and the
        // browser then fetches a file literally named null, which 404s.
        var imgSrc = mediaEl.currentSrc || mediaEl.src || mediaEl.getAttribute('src');
        if (imgSrc) {
          quickshopImage.src = imgSrc;
          quickshopImage.style.display = '';
        } else {
          quickshopImage.removeAttribute('src');
          quickshopImage.style.display = 'none';
        }
        quickshopVideo.style.display = 'none';
        quickshopVideo.pause();
      }
      quickshop.classList.add('is-open');
      quickshop.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      /* Same contract as the cart drawer: take focus, hold it, give it
         back. The opener is read here rather than passed in because this
         is reachable from a card click, a keyboard activation and the
         exposed SOLQuickshop.open, and only the live focus knows which. */
      if (releaseQuickshopFocus) releaseQuickshopFocus();
      var qsOpener = document.activeElement;
      if (!qsOpener || qsOpener === document.body) qsOpener = null;
      releaseQuickshopFocus = trapFocus(quickshop, qsOpener);
    };
    var closeQuickshop = function () {
      quickshop.classList.remove('is-open');
      quickshop.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      quickshopVideo.pause();
      if (releaseQuickshopFocus) { releaseQuickshopFocus(); releaseQuickshopFocus = null; }
    };

    qsa('[data-carousel-quickshop-close]', quickshop).forEach(function (btn) {
      btn.addEventListener('click', closeQuickshop);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuickshop();
    });

    window.SOLQuickshop = { open: openQuickshop, close: closeQuickshop };

    /* Feature-grid cards: click the photo/video to shop it */
    qsa('.feature-card__media').forEach(function (media) {
      media.addEventListener('click', function (e) {
        if (e.target.closest('[data-replay-video]')) return;
        openQuickshop(media.querySelector('video') || media.querySelector('img'));
      });
    });

    /* Key-features pinned-scroll imagery: click the active photo/video to shop it */
    qsa('.key-features__media, .key-features__slide-image').forEach(function (media) {
      media.addEventListener('click', function () {
        var activeSlide = media.querySelector('.key-features__media-slide.is-active') || media;
        openQuickshop(activeSlide.querySelector('video') || activeSlide.querySelector('img'));
      });
    });
  })();

  /* ---------------- Accordion ---------------- */
  qsa('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion-item');
      var panel = item.querySelector('[data-accordion-panel]');
      var isOpen = item.classList.contains('is-open');
      if (isOpen) {
        panel.style.maxHeight = null;
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ---------------- Gallery pre-warm ----------------
     Inactive slides are display:none, and a display:none image with
     loading="lazy" is never near the viewport, so the browser defers the fetch
     indefinitely. Clicking a thumbnail then started a cold download. Warm them
     once the page is idle so switching is instant. */
  (function () {
    var imgs = qsa('.product-gallery__slide img, .featured-product__gallery .product-gallery__slide img');
    if (!imgs.length) return;

    var warmOne = function (img, delay) {
      if (img.dataset.warmed || (img.complete && img.naturalWidth)) return;
      img.dataset.warmed = '1';
      // Stagger so the warm-up never competes with the active slide or the
      // rest of the page for bandwidth.
      setTimeout(function () {
        img.loading = 'eager';
        var pre = new Image();
        if (img.sizes) pre.sizes = img.sizes;
        if (img.srcset) pre.srcset = img.srcset;
        pre.src = img.currentSrc || img.src;
      }, delay);
    };

    // The full gallery is ~1.6MB over 20 images. Warm only the first handful up
    // front, which covers where shoppers actually click, and pull the rest in
    // once they show intent by touching the gallery at all.
    var FIRST = 6;
    var warm = function () {
      imgs.slice(0, FIRST).forEach(function (img, i) { warmOne(img, i * 120); });
    };
    var warmRest = function () {
      imgs.slice(FIRST).forEach(function (img, i) { warmOne(img, i * 90); });
    };
    var gallery = qs('.product-gallery');
    if (gallery) {
      ['pointerdown', 'touchstart', 'keydown'].forEach(function (evt) {
        gallery.addEventListener(evt, warmRest, { once: true, passive: true });
      });
    }

    if (document.readyState === 'complete') {
      'requestIdleCallback' in window ? requestIdleCallback(warm, { timeout: 2000 }) : setTimeout(warm, 400);
    } else {
      window.addEventListener('load', function () {
        'requestIdleCallback' in window ? requestIdleCallback(warm, { timeout: 2000 }) : setTimeout(warm, 400);
      });
    }
  })();

  /* ---------------- Bottom buy bar: one tap adds the chosen interior and goes to checkout ---------------- */
  (function () {
    var bar = qs('[data-buy-bar]');
    if (!bar) return;
    var buyRow = qs('.product-page__buy-row') || qs('.featured-product__buy-row');

    // The bar is fixed, so it sits on top of whatever is at the bottom of the
    // viewport - fine while scrolling past the middle of the page, but at the
    // true bottom of the page there is nothing further to scroll to, and the
    // footer's last ~100px was landing permanently underneath it with no way
    // to ever see it. Reserve exactly that much space at the end of the page,
    // measured from the bar's own rendered position rather than a guessed
    // constant, since the bar's height changes with how many lines the
    // product name and color labels wrap to, and its footprint differs
    // between the full-width mobile band and the floating desktop pill.
    var syncBuyBarSpace = function () {
      if (bar.classList.contains('is-visible')) {
        var space = Math.max(0, Math.round(window.innerHeight - bar.getBoundingClientRect().top));
        document.body.style.paddingBottom = space + 'px';
      } else {
        document.body.style.paddingBottom = '';
      }
    };

    /* Where there is a "Two interiors" section, that is the gate. The bar
       asks which lining you want, and before that section a shopper has not
       been shown the two linings side by side and has no basis to answer -
       the bar was arriving during the gallery, covering the photographs,
       asking a question the page had not got to yet.

       It shows from the moment that section comes into view and for the
       rest of the page below it, and hides again if the shopper scrolls back
       up above it - the same line both ways (owner's call, Oct 2026; it used
       to stay on for good once reached). The line is the section's top edge
       crossing the bottom of the screen.

       A scroll check rather than an IntersectionObserver: an observer only
       fires when the section crosses the screen edge, so a jump straight
       from the footer to the top (an iPhone status-bar tap) never passed
       through it and left the bar showing over the gallery.

       Everywhere else - the homepage featured product, any page with a buy
       row and no interior section - the old rule stands: show the bar
       whenever the real controls are off screen in either direction, so a
       shopper up in the gallery still has a way to buy. */
    var interiorGate = qs('.interior-choice');
    if (interiorGate) {
      var gateTicking = false;
      var checkGate = function () {
        gateTicking = false;
        var reached = interiorGate.getBoundingClientRect().top < window.innerHeight;
        if (reached !== bar.classList.contains('is-visible')) {
          bar.classList.toggle('is-visible', reached);
          syncBuyBarSpace();
        }
      };
      var queueGate = function () {
        if (gateTicking) return;
        gateTicking = true;
        requestAnimationFrame(checkGate);
      };
      window.addEventListener('scroll', queueGate, { passive: true });
      window.addEventListener('resize', queueGate);
      checkGate();
    } else if (buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
          syncBuyBarSpace();
        });
      }, { threshold: 0 }).observe(buyRow);
    } else {
      bar.classList.add('is-visible');
      syncBuyBarSpace();
    }

    window.addEventListener('resize', debounce(syncBuyBarSpace, 150));

    qsa('[data-buy-now]', bar).forEach(function (btn) {
      btn.addEventListener('click', function () {
        buyNow(btn, btn.getAttribute('data-buy-now'), 'Buy bar (straight to checkout)');
      });
    });
  })();

  /* ---- Interior choice cards ------------------------------------------
     The comparison section is where the color decision actually gets made, so
     the card IS the buy button: one tap picks the lining and goes to checkout.
     The swatch row on the page is kept in sync first, so if the shopper comes
     back from checkout the option they chose is still selected. */
  (function () {
    var cards = qsa('[data-interior-pick]');
    if (!cards.length) return;

    function syncOptionRow(value) {
      qsa('[data-option-value-btn], [data-fp-option-value-btn]').forEach(function (btn) {
        if (btn.disabled) return;
        if (btn.getAttribute('data-value') === value) btn.click();
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.disabled) return;
        cards.forEach(function (c) { c.classList.toggle('is-picked', c === card); });
        syncOptionRow(card.getAttribute('data-interior-pick'));
        buyNow(card, card.getAttribute('data-buy-now'), 'Interior card (straight to checkout)');
      });
    });
  })();
  /* ---- Owners module ---------------------------------------------------
     The card that drops in under the header (snippets/purchase-popup.liquid
     renders the shell and a JSON config; everything else is here because
     this file owns the bag drawer and the Entry stamp).

     Real data only. A card whose data is missing, stale or too small to say
     something true is skipped, never filled in. No names, no clock times,
     no sales totals, no shipping-speed promises.

     Pacing: nothing while the bag has anything in it; the first card once
     the visitor has scrolled a screen or after 12 seconds; at most three
     cards per visit, 25 to 40 seconds apart, each held for 8 seconds (longer
     while hovered or focused). Each visit opens with "Someone just bought"
     and draws the other two at random from the remaining cards. */
  (function () {
    var el = qs('[data-purchase-pop]');
    var cfgEl = qs('[data-owners-config]');
    if (!el || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg || cfg.cartCount > 0) return;

    var body = el.querySelector('[data-purchase-pop-body]');
    var V = cfg.variants || {};
    var on = cfg.cards || {};
    var feed = cfg.feed || null;
    var DAY = 24 * 60 * 60 * 1000;
    function fresh(through) {
      var t = Date.parse(through || '');
      return !isNaN(t) && Date.now() - t < 4 * DAY;
    }
    var feedOk = !!feed && fresh(feed.through);
    var NAME = { carbon: 'Carbon Black', red: 'Signature Red' };
    var STATE_NAMES = { AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'Washington, DC',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming' };

    /* Small pieces of markup. Text from the feed goes through esc(); it is
       our own task's output, but a city name is still data. */
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    var LIVE = '<span class="purchase-pop__live" aria-hidden="true"></span>';
    var WARN = '<span class="purchase-pop__live purchase-pop__live--warn" aria-hidden="true"></span>';
    function dot(c) { return '<span class="purchase-pop__dot purchase-pop__dot--' + c + '" aria-hidden="true"></span>'; }
    function img(src) { return src ? '<img class="purchase-pop__img" src="' + esc(src) + '" alt="" width="64" height="64" loading="lazy">' : ''; }
    function tile(inner) { return '<span class="purchase-pop__tile" aria-hidden="true">' + inner + '</span>'; }
    var ICON_BAG = '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" stroke-linecap="round"><path d="M7 11h18l-1.4 15.2a2 2 0 0 1-2 1.8H10.4a2 2 0 0 1-2-1.8z"/><path d="M12 14v-4a4 4 0 0 1 8 0v4"/></svg>';
    var ICON_PEOPLE = '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"><circle cx="12" cy="11" r="4"/><path d="M4 26c0-4.4 3.6-8 8-8s8 3.6 8 8"/><circle cx="22" cy="12" r="3.2"/><path d="M21 18.2c4 .2 7 3.4 7 7.8"/></svg>';
    var ICON_TREND = '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" stroke-linecap="round"><path d="M4 23l8-8 5 5 11-11"/><path d="M20 9h8v8"/></svg>';

    /* The tile map: one square per state on an 11 x 8 grid. */
    var TILES = { AK:[0,0],ME:[0,10],WI:[1,5],VT:[1,9],NH:[1,10],WA:[2,0],ID:[2,1],MT:[2,2],ND:[2,3],MN:[2,4],IL:[2,5],MI:[2,6],NY:[2,8],MA:[2,9],
      OR:[3,0],NV:[3,1],WY:[3,2],SD:[3,3],IA:[3,4],IN:[3,5],OH:[3,6],PA:[3,7],NJ:[3,8],CT:[3,9],RI:[3,10],
      CA:[4,0],UT:[4,1],CO:[4,2],NE:[4,3],MO:[4,4],KY:[4,5],WV:[4,6],VA:[4,7],MD:[4,8],DE:[4,9],
      AZ:[5,1],NM:[5,2],KS:[5,3],AR:[5,4],TN:[5,5],NC:[5,6],SC:[5,7],DC:[5,8],OK:[6,3],LA:[6,4],MS:[6,5],AL:[6,6],GA:[6,7],HI:[7,0],TX:[7,3],FL:[7,8] };
    function map(classFor) {
      var h = '<span class="purchase-pop__map">';
      for (var st in TILES) {
        h += '<i class="' + (classFor(st) || '') + '" style="grid-row:' + (TILES[st][0] + 1) + ';grid-column:' + (TILES[st][1] + 1) + '"></i>';
      }
      return '<span class="purchase-pop__tile purchase-pop__tile--map" aria-hidden="true">' + h + '</span></span>';
    }
    var LOWER48 = Object.keys(TILES).filter(function (s) { return s !== 'AK' && s !== 'HI' && s !== 'DC'; });

    function price(v) { return v ? formatMoney(v.price) : ''; }
    /* The product page makes the shopper choose an interior: the form's
       hidden id holds Carbon from the start, so it can't be trusted on its
       own. Only a fully chosen form counts; otherwise null, and the button
       sends them to the picker instead of adding a colour they didn't pick. */
    var productForm = qs('form.product-form') || qs('form[action*="/cart/add"]');
    function selectedVariantId() {
      if (!productForm) return null;
      var groups = qsa('[data-option-index], [data-fp-option-index]', productForm);
      var chosen = groups.every(function (g) { return g.querySelector('.is-selected'); });
      var input = productForm.querySelector('[name="id"]');
      return chosen && input && input.value ? Number(input.value) : null;
    }
    var fromPrice = (function () {
      var p = [V.carbon, V.red].filter(Boolean).map(function (v) { return v.price; });
      return p.length ? formatMoney(Math.min.apply(null, p)) : '';
    })();

    /* A button either adds straight to the bag (product page) or, anywhere
       else, goes to the product page with the colour already chosen. */
    function btn(label, opts) {
      opts = opts || {};
      var cls = 'purchase-pop__btn' + (opts.ghost ? ' purchase-pop__btn--ghost' : opts.light ? ' purchase-pop__btn--light' : opts.pre ? ' purchase-pop__btn--pre' : opts.red ? ' purchase-pop__btn--red' : '');
      if (!cfg.onProduct) {
        /* Off the product page a second, lesser choice would be a second
           link to the same page. */
        if (opts.ghost) return '';
        var href = cfg.productUrl + (opts.ids && opts.ids.length === 1 ? '?variant=' + opts.ids[0] : '');
        return '<a class="' + cls + '" href="' + esc(href) + '">' + (opts.shop || 'Shop now') + '</a>';
      }
      return '<button type="button" class="' + cls + '" data-op-add="' + (opts.ids ? opts.ids.join(',') : 'selected') + '"' + (opts.label ? ' data-op-label="' + esc(opts.label) + '"' : '') + '><span class="purchase-pop__btn-label">' + label + '</span><span class="purchase-pop__spin" aria-hidden="true"></span></button>';
    }
    function colourOf(v) { return v === 'red' ? 'red' : 'carbon'; }
    function variantBtn(c, label) {
      var v = V[c]; if (!v) return '';
      return btn(dot(c) + label + ' <span class="purchase-pop__price">· ' + price(v) + '</span>', { ids: [v.id], red: c === 'red', shop: 'Shop ' + NAME[c] });
    }
    function place(city, state) {
      if (!state) return '';
      return city ? esc(city) + ', ' + esc(state) : esc(STATE_NAMES[state] || state);
    }

    /* Which colour "Match it" shows this time: alternates within a visit,
       starting from whichever shipped most recently. */
    var MATCH_KEY = 'sol:owners:match';
    function matchColour() {
      var latest = (feed && feed.latest) || {};
      var avail = ['carbon', 'red'].filter(function (c) { return latest[c] && latest[c].state && V[c]; });
      if (!avail.length) return null;
      if (avail.length === 1) return avail[0];
      var last = null;
      try { last = sessionStorage.getItem(MATCH_KEY); } catch (e) {}
      var pick = last ? (last === 'red' ? 'carbon' : 'red') : (feed.newest === 'red' ? 'red' : 'carbon');
      try { sessionStorage.setItem(MATCH_KEY, pick); } catch (e) {}
      return pick;
    }

    function daysAgo(day) {
      var t = Date.parse((day || '') + 'T12:00:00');
      if (isNaN(t)) return null;
      var now = new Date(); now.setHours(12, 0, 0, 0);
      return Math.round((now.getTime() - t) / DAY);
    }
    /* Orders from the past month, newest first. Today's read "Just
       bought"; anything older "Recently bought", so the verb is always
       true. The day shows only when it is Today. */
    function recentList() {
      var list = (feedOk && feed.recent) || [];
      return list.filter(function (o) {
        var d = daysAgo(o && o.day);
        return o && o.place && o.state && V[o.variant === 'red' ? 'red' : 'carbon'] && d !== null && d >= 0 && d <= 30 && !((+o.pre || 0) > 0);
      });
    }
    function verb(o) { return daysAgo(o.day) === 0 ? 'Just bought' : 'Recently bought'; }
    /* Rotates through the whole list, carried across visits, so a
       returning visitor sees the next order rather than the same one. */
    var RECENT_KEY = 'sol:owners:recent';
    /* The first card of a visit always shows a pair order when there is
       one in the window, rotating through the pairs from visit to visit.
       Later cards rotate through every order as before. */
    var PAIR_KEY = 'sol:owners:pair';
    function isPair(o) { return o.items && ((+o.items.carbon || 0) + (+o.items.red || 0)) >= 2; }
    /* start: where a first-time visitor begins. Without it everyone new
       sees the newest order; card 1 passes a random start so first visits
       spread across the month's two-Carbon customers. */
    function nextIndex(key, start) {
      var i = start || 0;
      try {
        var prev = parseInt(localStorage.getItem(key), 10);
        if (!isNaN(prev)) i = prev + 1;
        localStorage.setItem(key, String(i));
      } catch (e) {}
      return i;
    }
    function recentOrder() {
      var list = recentList();
      if (!list.length) return null;
      /* Card 1 prefers an order of exactly two Carbon Black; any pair when
         the month has none of those. */
      var twoCarbon = list.filter(function (o) { return o.items && +o.items.carbon === 2 && !(+o.items.red); });
      var pairs = twoCarbon.length ? twoCarbon : list.filter(isPair);
      var pairSlot = shown === 0;
      var o = pairSlot && pairs.length ? pairs[nextIndex(PAIR_KEY, Math.floor(Math.random() * pairs.length)) % pairs.length] : list[nextIndex(RECENT_KEY) % list.length];
      /* items: cases by colour in this one order, e.g. {carbon:1, red:1}.
         Older feed entries only carry "variant", so fall back to one case. */
      var items = { carbon: 0, red: 0 };
      if (o.items) { items.carbon = +o.items.carbon || 0; items.red = +o.items.red || 0; }
      if (!items.carbon && !items.red) items[o.variant === 'red' ? 'red' : 'carbon'] = 1;
      if (items.carbon && !V.carbon) items.carbon = 0;
      if (items.red && !V.red) items.red = 0;
      var qty = items.carbon + items.red;
      return { c: items.red && !items.carbon ? 'red' : 'carbon', items: items, qty: qty, mixed: items.carbon > 0 && items.red > 0,
        place: o.place, state: o.state, near: !!o.near, today: daysAgo(o.day) === 0, verb: verb(o) };
    }
    var COUNT_WORD = ['', 'a', 'two', 'three', 'four', 'five', 'six'];
    /* What they bought, in words: "bought the Voyager in Carbon Black";
       for a pair the top line already says "a pair", so this says which:
       "one Carbon Black, one Signature Red" or "both in Signature Red". */
    function boughtWhat(r) {
      if (r.qty <= 1) return 'bought the Voyager in ' + NAME[r.c];
      if (r.mixed && r.qty === 2) return 'one Carbon Black, one Signature Red';
      if (r.mixed) return 'in Carbon Black and Signature Red';
      return (r.qty === 2 ? 'both' : 'all ' + (COUNT_WORD[r.qty] || r.qty)) + ' in ' + NAME[r.c];
    }
    function recentMedia(r) {
      if (r.qty <= 1) return img(V[r.c].img);
      var a = r.mixed ? V.carbon.img : V[r.c].img, b = r.mixed ? V.red.img : V[r.c].img;
      return '<span class="purchase-pop__pair" aria-hidden="true">' + img(a) + img(b) + '</span>';
    }
    /* "Get the same" buys what they bought: one case, or the same pair. */
    function recentBtn(r) {
      if (r.qty <= 1) return variantBtn(r.c, 'Get the same');
      var ids = [], cents = 0;
      ['carbon', 'red'].forEach(function (c) { for (var k = 0; k < r.items[c]; k++) { ids.push(V[c].id); cents += V[c].price; } });
      return btn('Get the same ' + (r.qty === 2 ? 'pair' : r.qty) + ' <span class="purchase-pop__price">· ' + formatMoney(cents) + '</span>',
        { ids: ids, red: !r.mixed && r.c === 'red', shop: 'Shop the pair' });
    }

    /* Buttons for a set of cases: ids and total for e.g. {carbon:1, red:1}. */
    function setOf(items) {
      var ids = [], cents = 0;
      ['carbon', 'red'].forEach(function (c) { for (var k = 0; k < (items[c] || 0); k++) { ids.push(V[c].id); cents += V[c].price; } });
      return { ids: ids, total: formatMoney(cents) };
    }
    /* The pair rate (feed.pair_pct, past 7 days) as the card says it:
       "1 in 3 customers" with a 33% tile when it rounds cleanly to a third, "1 in 4"
       with 25% for a quarter, otherwise the plain percentage. The tile and
       the sentence always agree. Said as customers: in a 7-day window a
       repeat order is rare, so orders and customers are the same count.
       Null when the feed can't back it. */
    function pairRate() {
      var p = feedOk && feed.pair_pct;
      if (!(p >= 10)) return null;
      if (p >= 31 && p <= 36) return { pct: 33, head: '1 in 3 customers order a pair' };
      if (p >= 23 && p <= 27) return { pct: 25, head: '1 in 4 customers order a pair' };
      p = Math.floor(p);
      return { pct: p, head: p + '% of customers order a pair' };
    }
    /* Every card with a Red button says when Red ships while it's on
       preorder; the button alone doesn't. */
    function redNote(text) {
      return PRE.red ? dot('red') + esc(text || ('Signature Red ships ' + (PRE.ships || 'January 2027'))) : '';
    }

    /* Just preordered: real orders from the last three weeks whose line
       carried the "Preorder" property, i.e. a colour bought after it sold
       out. Only while that colour is actually on preorder. */
    var PRE = cfg.preorder || {};
    var PRE_KEY = 'sol:owners:preorder';
    var MIXED_KEY = 'sol:owners:mixed';
    var TOGETHER_KEY = 'sol:owners:together';
    function preorderList() {
      if (!PRE.red || !V.red) return [];
      var list = (feedOk && feed.recent) || [];
      return list.filter(function (o) {
        var d = daysAgo(o && o.day);
        return o && o.place && o.state && (+o.pre || 0) > 0 && d !== null && d >= 0 && d <= 21;
      });
    }

    function visitedSub(states) {
      var all48 = LOWER48.every(function (s) { return states.indexOf(s) > -1; });
      if (!all48) return 'From coast to coast';
      var extra = ['HI', 'AK'].filter(function (s) { return states.indexOf(s) > -1; }).map(function (s) { return STATE_NAMES[s]; });
      return 'All of the lower 48' + (extra.length ? ', plus ' + extra.join(' and ') : '');
    }

    /* Each builder returns a card, or null when its data cannot back it. */
    var BUILD = {
      match: function () {
        if (!feedOk) return null;
        var c = matchColour(); if (!c) return null;
        var s = feed.latest[c];
        return { name: 'Match it', log: 'Match it · ' + NAME[c], media: img(V[c].img),
          kicker: LIVE + 'Just shipped to ' + place(s.city, s.state), head: NAME[c] + ' interior',
          sub: 'Free ground shipping in the continental U.S.', buttons: [variantBtn(c, 'Add the same one')] };
      },
      carts: function () {
        var a = cfg.adds;
        if (!a || !fresh(a.through) || !(a.count >= 20)) return null;
        return { name: 'Added to cart recently', media: tile(ICON_BAG),
          kicker: LIVE + 'Popular right now', head: a.count + ' added to cart recently',
          sub: 'Free ground shipping in the continental U.S.', buttons: [] };
      },
      low: function () {
        var lows = ['red', 'carbon'].filter(function (c) {
          var v = V[c]; return v && v.tracked && v.available && v.qty > 0 && v.qty <= cfg.lowThreshold;
        });
        if (!lows.length) return null;
        var c = lows.sort(function (a, b) { return V[a].qty - V[b].qty; })[0];
        var other = c === 'red' ? 'carbon' : 'red';
        var under = Math.ceil(V[c].qty / 10) * 10;
        if (under === V[c].qty) under += 10;
        var otherOk = V[other] && V[other].available && !(V[other].tracked && V[other].qty <= cfg.lowThreshold);
        return { name: 'Running low', media: img(V[c].img),
          kicker: WARN + 'Running low', head: 'Fewer than ' + under + ' ' + NAME[c] + ' left',
          sub: otherOk ? NAME[other] + ' is well stocked' : 'Both interiors are selling down',
          buttons: [variantBtn(c, 'Get ' + NAME[c])] };
      },
      /* The pair rate, leading with two Carbon (a pair that ships now) and
         Carbon + Red as the second choice. A first-time visitor has not
         seen the colours yet, so the buttons name them. */
      pair: function () {
        var rate = pairRate();
        if (!rate || !V.carbon) return null;
        var p = rate.pct, head = rate.head;
        var two = setOf({ carbon: 2 });
        var buttons = [btn('Two Carbon <span class="purchase-pop__price">· ' + two.total + '</span>', { ids: two.ids, label: 'Two Carbon', shop: 'Shop the pair' })];
        if (V.red) {
          var mix = setOf({ carbon: 1, red: 1 });
          buttons.push(btn('Carbon + Red <span class="purchase-pop__price">· ' + mix.total + '</span>', { ids: mix.ids, ghost: true, label: 'One of each' }));
        }
        var m = new Date().getMonth();
        return { name: 'One to keep, one to give', log: 'Pair rate',
          media: '<span class="purchase-pop__tile purchase-pop__stat" aria-hidden="true"><b>' + p + '%</b></span>',
          kicker: 'One to keep, one to give', head: head,
          sub: m >= 9 ? 'Gifting season starts here.' : 'Keep one, give one.',
          buttons: buttons, fine: V.red && cfg.onProduct ? redNote() : '' };
      },
      /* One of each: a real order of one Carbon and one Red from the past
         month. While Red is on preorder the two cases arrive apart, and
         the card says so. */
      mixed: function () {
        if (!V.carbon || !V.red) return null;
        var list = recentList().filter(function (o) { return o.items && +o.items.carbon === 1 && +o.items.red === 1; });
        if (!list.length) return null;
        var o = list[nextIndex(MIXED_KEY) % list.length], today = daysAgo(o.day) === 0;
        var mix = setOf({ carbon: 1, red: 1 });
        return { name: 'One of each, recently', log: 'One of each · ' + (o.near ? 'near ' : '') + o.place,
          media: '<span class="purchase-pop__pair" aria-hidden="true">' + img(V.carbon.img) + img(V.red.img) + '</span>',
          kicker: LIVE + verb(o) + ' a pair', head: 'Someone ' + (o.near ? 'near ' : 'in ') + esc(o.place),
          sub: '<span class="purchase-pop__nowrap">' + dot('carbon') + 'Carbon Black</span> <span class="purchase-pop__nowrap">' + dot('red') + 'Signature Red</span>' + (today ? ' · Today' : ''),
          buttons: [btn('Carbon + Red <span class="purchase-pop__price">· ' + mix.total + '</span>', { ids: mix.ids, label: 'One of each', shop: 'Shop the pair' })],
          fine: PRE.red ? 'Carbon in stock · ' + redNote() : '' };
      },
      /* Bought together: a pair order shown product first, two large case
         images with a "+". Tall, so the desktop product page only. */
      together: function () {
        if (!cfg.onProduct || (window.innerWidth || 0) < 750) return null;
        var list = recentList().filter(function (o) { return o.items && (+o.items.carbon || 0) + (+o.items.red || 0) === 2; });
        if (!list.length) return null;
        var o = list[nextIndex(TOGETHER_KEY) % list.length];
        var cs = [];
        for (var k = 0; k < (+o.items.carbon || 0); k++) cs.push('carbon');
        for (k = 0; k < (+o.items.red || 0); k++) cs.push('red');
        if (cs.some(function (c) { return !V[c]; })) return null;
        var set = setOf(o.items);
        var big = function (c) {
          var src = String(V[c].img || '').replace(/([?&])width=\d+/, '$1width=320');
          return '<figure class="purchase-pop__fig">' + (src ? '<img src="' + esc(src) + '" alt="" width="120" height="120" loading="lazy">' : '') +
            '<figcaption>' + NAME[c] + '<br><b>' + price(V[c]) + '</b></figcaption></figure>';
        };
        return { name: 'Bought together', log: 'Bought together · ' + (o.near ? 'near ' : '') + o.place,
          html: '<div class="purchase-pop__together">' + big(cs[0]) + '<span class="purchase-pop__plus" aria-hidden="true">+</span>' + big(cs[1]) + '</div>' +
            '<p class="purchase-pop__kicker purchase-pop__kicker--center">' + LIVE + verb(o).replace('bought', 'bought together') + ' ' + (o.near ? 'near ' : 'in ') + esc(o.place) + '</p>',
          buttons: [btn('Add both <span class="purchase-pop__price">· ' + set.total + '</span>', { ids: set.ids, red: cs[0] === 'red' && cs[1] === 'red', label: 'Same pair' })],
          fine: cs.indexOf('red') > -1 ? redNote() : '' };
      },
      visited: function () {
        var st = feedOk && feed.visitor_states;
        if (!st || st.length < 10) return null;
        return { name: 'Visited recently by states', media: map(function (s) { return st.indexOf(s) > -1 ? 'on' : ''; }),
          kicker: LIVE + 'Popular right now', head: 'Visited recently by ' + st.length + ' states', sub: visitedSub(st),
          buttons: [btn('Add yours <span class="purchase-pop__price">· from ' + fromPrice + '</span>')] };
      },
      pick: function () {
        var p = feedOk && feed.pick;
        if (!p || !V[colourOf(p.variant)] || !(p.pct >= 55)) return null;
        var c = colourOf(p.variant);
        return { name: "This week's pick", media: img(V[c].img),
          kicker: "This week's favorite", head: NAME[c] + ' interior', sub: 'Chosen by ' + Math.floor(p.pct) + '% of customers this week',
          buttons: [variantBtn(c, 'Choose ' + NAME[c])] };
      },
      /* Up to three of the newest places in one line, cities only: a
         small-town order is left out rather than named by its state or a
         nearby city. */
      recent3: function () {
        var list = recentList(); if (list.length < 2) return null;
        var seen = {}, places = [], states = [], colours = {}, used = [];
        list.forEach(function (o) {
          if (o.near) return;
          var label = String(o.place).split(',')[0];
          if (seen[label] || places.length >= 3) return;
          seen[label] = 1; used.push(o); places.push(esc(label)); states.push(o.state); colours[o.variant === 'red' ? 'red' : 'carbon'] = 1;
        });
        if (places.length < 2) return null;
        var head = places.length === 2 ? places.join(' & ') : places[0] + ', ' + places[1] + ' & ' + places[2];
        var sub = colours.carbon && colours.red ? 'Carbon Black and Signature Red' : NAME[colours.red ? 'red' : 'carbon'] + ' interior';
        return { name: 'Three recent places', media: map(function (st) { return states.indexOf(st) > -1 ? 'pulse' : ''; }),
          kicker: LIVE + (used.every(function (o) { return verb(o) === 'Just bought'; }) ? 'Just bought' : 'Recently bought') + ' in', head: head, sub: sub,
          buttons: [btn('Add yours <span class="purchase-pop__price">· from ' + fromPrice + '</span>')] };
      },
      /* Visitors over three weeks. Rounded down to the hundred; "Nearly"
         only when within 5% of the next thousand. Hidden under 500. */
      visitors: function () {
        var n = feedOk && feed.visitors;
        if (!(n >= 500)) return null;
        var next = Math.ceil(n / 1000) * 1000;
        var label = next - n <= next * 0.05 ? 'Nearly ' + next.toLocaleString('en-US') : (Math.floor(n / 100) * 100).toLocaleString('en-US') + '+';
        var st = feed.visitor_states || [];
        return { name: 'Nearly 2,000 shoppers', media: tile(ICON_PEOPLE),
          kicker: LIVE + 'Popular right now', head: label + ' shoppers visited recently',
          sub: st.length >= 48 && LOWER48.every(function (s) { return st.indexOf(s) > -1; }) ? 'From all of the lower 48' : 'From coast to coast',
          buttons: [] };
      },
      trend: function () {
        if (!feedOk || !(feed.trend_pct >= 15)) return null;
        var pct = Math.floor(feed.trend_pct / 10) * 10;
        return { name: 'Interest is up', media: tile(ICON_TREND),
          kicker: 'Trending', head: 'Interest is up ' + pct + '% from last week', sub: 'More shoppers than the week before', buttons: [] };
      },
      leadmap: function () {
        var l = feedOk && feed.lead;
        if (!l || !l.carbon || !l.red || !l.carbon.length || !l.red.length || !V.carbon || !V.red) return null;
        return { name: 'Red or Carbon, by state',
          media: map(function (s) { return l.carbon.indexOf(s) > -1 ? 'carbon' : l.red.indexOf(s) > -1 ? 'red' : ''; }),
          kicker: 'Red or Carbon?', head: 'Depends where you live',
          sub: '<span class="purchase-pop__nowrap">' + dot('carbon') + 'Carbon: ' + l.carbon.slice(0, 3).join(', ') + '</span> <span class="purchase-pop__nowrap">' + dot('red') + 'Red: ' + l.red.slice(0, 2).join(', ') + '</span>',
          buttons: [
            btn('Red <span class="purchase-pop__price">· ' + price(V.red) + '</span>', { ids: [V.red.id], red: true, shop: 'Shop Red' }),
            btn('Carbon <span class="purchase-pop__price">· ' + price(V.carbon) + '</span>', { ids: [V.carbon.id], shop: 'Shop Carbon' })
          ] };
      },
      justmap: function () {
        if (!feedOk || !feed.latest) return null;
        var c = feed.newest === 'red' ? 'red' : 'carbon';
        var s = feed.latest[c];
        if (!s || !s.state || !V[c]) return null;
        /* Only the destination lights up. Lighting every state we've
           shipped to (or naming how many) reads small this early on. */
        return { name: 'Just shipped, on the map',
          media: map(function (st) { return st === s.state ? 'pulse' : ''; }),
          kicker: LIVE + 'Just shipped to ' + place(s.city, s.state), head: NAME[c] + ' interior',
          sub: 'Free ground shipping in the continental U.S.',
          buttons: [variantBtn(c, 'Add the same one')] };
      },
      /* Recently purchased: the newest real order. The feed gives the place
         (a small town arrives as "near <city>"), the colour and the day it
         was ordered. Only today's orders say "Just bought", older ones
         "Recently bought"; the day shows only when it is Today. */
      preorder: function () {
        var list = preorderList(); if (!list.length) return null;
        var o = list[nextIndex(PRE_KEY) % list.length];
        var n = +o.pre || 1, today = daysAgo(o.day) === 0;
        var head = 'Someone ' + (o.near ? 'near ' : 'in ') + esc(o.place);
        var ships = '<br>Ships ' + esc(PRE.ships || 'January 2027');
        var log = 'Preorder · ' + n + ' Red · ' + (o.near ? 'near ' : '') + o.place;
        var chip = '<span class="purchase-pop__prechip">Preorder</span>';
        /* A preorder of two reads as a pair and offers the same two first. */
        if (n === 2) {
          var two = setOf({ red: 2 });
          return { name: 'Just preordered a pair', log: log,
            media: '<span class="purchase-pop__prewrap"><span class="purchase-pop__pair" aria-hidden="true">' + img(V.red.img) + img(V.red.img) + '</span>' + chip + '</span>',
            kicker: LIVE + (today ? 'Just preordered a pair' : 'Recently preordered a pair'), head: head,
            sub: 'Two Signature Red' + (today ? ' · Today' : '') + ships,
            buttons: [
              btn('Preorder two <span class="purchase-pop__price">· ' + two.total + '</span>', { ids: two.ids, pre: true, label: 'Two Red', shop: 'Preorder Signature Red' }),
              btn('Just one <span class="purchase-pop__price">· ' + price(V.red) + '</span>', { ids: [V.red.id], ghost: true, label: 'One Red' })
            ] };
        }
        var what = (n === 1 ? 'reserved a' : 'reserved ' + (COUNT_WORD[n] || n)) + ' Signature Red';
        return { name: 'Just preordered', log: log,
          media: '<span class="purchase-pop__prewrap">' + img(V.red.img) + chip + '</span>',
          kicker: LIVE + (today ? 'Just preordered' : 'Recently preordered'), head: head,
          sub: what + (today ? ' · Today' : '') + ships,
          buttons: [btn('Preorder yours <span class="purchase-pop__price">· ' + price(V.red) + '</span>', { ids: [V.red.id], pre: true, shop: 'Preorder Signature Red' })] };
      },
      recent: function () {
        var r = recentOrder(); if (!r) return null;
        var buttons = [recentBtn(r)], fine = '';
        /* A same-colour pair offers just that pair, named by colour. No
           Carbon + Red second choice: owner wants card 1 to stay on the
           two-Carbon pair that was actually bought. */
        if (r.qty === 2 && !r.mixed && V[r.c]) {
          var same = setOf(r.items);
          buttons = [btn('Two ' + (r.c === 'red' ? 'Red' : 'Carbon') + ' <span class="purchase-pop__price">· ' + same.total + '</span>', { ids: same.ids, red: r.c === 'red', label: 'Same pair', shop: 'Shop the pair' })];
          if (r.c === 'red' && cfg.onProduct) fine = redNote();
        }
        return { name: 'Recently purchased', log: 'Just bought · ' + (r.qty >= 2 ? 'Pair' : 'Single') + ' · ' + (r.near ? 'near ' : '') + r.place, media: recentMedia(r),
          kicker: LIVE + r.verb + (r.qty === 2 ? ' a pair' : r.qty > 2 ? ' ' + (COUNT_WORD[r.qty] || r.qty) + ' cases' : ''),
          head: 'Someone ' + (r.near ? 'near ' : 'in ') + esc(r.place),
          sub: boughtWhat(r) + (r.today ? ' · Today' : ''),
          buttons: buttons, fine: fine };
      },
      recentmap: function () {
        var r = recentOrder(); if (!r) return null;
        return { name: 'Recently purchased, on the map', log: 'Map · ' + (r.qty >= 2 ? 'Pair' : 'Single') + ' · ' + (r.near ? 'near ' : '') + r.place, media: map(function (st) { return st === r.state ? 'pulse' : ''; }),
          kicker: LIVE + r.verb + (r.qty === 2 ? ' a pair' : r.qty > 2 ? ' ' + (COUNT_WORD[r.qty] || r.qty) + ' cases' : '') + ' ' + (r.near ? 'near' : 'in'), head: esc(r.place),
          sub: (r.qty <= 1 ? NAME[r.c] + ' interior' : boughtWhat(r).replace(/^./, function (m) { return m.toUpperCase(); })) + (r.today ? ' · Today' : ''),
          buttons: [recentBtn(r)] };
      },
      visitedInfo: function () {
        var st = feedOk && feed.visitor_states;
        if (!st || st.length < 10) return null;
        return { name: 'Visited recently by states (info)', media: map(function (s) { return st.indexOf(s) > -1 ? 'on' : ''; }),
          kicker: 'Shoppers from coast to coast', head: 'Visited recently by ' + st.length + ' states', sub: visitedSub(st), buttons: [] };
      },
      /* For the gift list: brand voice rather than a fact, so it is the one
         card with no data behind it. November and December only. */
      gift: function () {
        var m = new Date().getMonth();
        if (!V.carbon || !(m === 10 || m === 11 || (forced && forced[1] === 'gift'))) return null;
        var two = setOf({ carbon: 2 });
        return { name: 'For the gift list', tone: 'dark',
          media: '<span class="purchase-pop__pair" aria-hidden="true">' + img(V.carbon.img) + img(V.carbon.img) + '</span>',
          kicker: 'For the gift list', head: 'One for your hat. One for theirs.',
          sub: 'Two cases, free ground shipping in the continental U.S.',
          buttons: [btn('Add two <span class="purchase-pop__price">· ' + two.total + '</span>', { ids: two.ids, light: true, label: 'Two Carbon', shop: 'Shop the pair' })] };
      },
      freeship: function () {
        return { name: 'Ships free across the lower 48', media: map(function (s) { return s === 'AK' || s === 'HI' ? '' : 'on'; }),
          kicker: 'Ships free across the lower 48', head: 'Free ground shipping', sub: 'In the continental U.S.',
          buttons: [btn('Add to bag <span class="purchase-pop__price">· from ' + fromPrice + '</span>')] };
      }
    };
    var ORDER = ['preorder', 'recent', 'recentmap', 'recent3', 'mixed', 'together', 'match', 'pick', 'leadmap', 'low', 'pair', 'gift', 'freeship'];
    var deck = ORDER.filter(function (id) { return on[id] !== false && BUILD[id]; });
    if (!deck.length) return;

    /* Session bookkeeping. */
    var STOP_KEY = 'solPurchasePopStopped';
    var SHOWN_KEY = 'sol:owners:shown';
    var PLAN_KEY = 'sol:owners:plan';
    var USED_KEY = 'sol:owners:groups';
    var PER_VISIT = 3;
    function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

    /* Each visit opens with "Someone just bought" (two Carbon Black when
       there is one) and then draws the other two at random from every remaining
       card. The draw is kept for the visit, so moving between pages
       doesn't reshuffle. */
    var FIRST = 'recent';
    function shuffle(a) {
      for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
      return a;
    }
    function makePlan(first) {
      var head = deck.indexOf(first) > -1 ? [first] : [];
      var rest = shuffle(deck.filter(function (id) { return head.indexOf(id) < 0; }));
      return head.concat(rest);
    }

    /* For checking the cards: ?owners on any URL clears this visit and
       shows a card straight away; ?owners=leadmap (any id from ORDER)
       starts with that card. */
    var forced = /[?&]owners(?:=(\w+))?(?:&|$)/.exec(window.location.search);
    if (forced) {
      try { [STOP_KEY, SHOWN_KEY, PLAN_KEY, USED_KEY].forEach(function (k) { sessionStorage.removeItem(k); }); } catch (e) {}
      if (forced[1] && deck.indexOf(forced[1]) > -1) sset(PLAN_KEY, JSON.stringify(makePlan(forced[1])));
    }
    if (sget(STOP_KEY) === '1') return;
    var shown = parseInt(sget(SHOWN_KEY), 10) || 0;
    if (shown >= PER_VISIT) return;
    var plan = null, used = [];
    try { plan = JSON.parse(sget(PLAN_KEY) || 'null'); used = JSON.parse(sget(USED_KEY) || '[]') || []; } catch (e) {}
    if (!plan || !plan.length) { plan = makePlan(FIRST); sset(PLAN_KEY, JSON.stringify(plan)); }
    var stopped = false;

    function render(card) {
      var btns = card.buttons.filter(Boolean);
      body.innerHTML = (card.html || ('<div class="purchase-pop__top">' + card.media +
        '<span class="purchase-pop__copy"><span class="purchase-pop__kicker">' + card.kicker + '</span>' +
        '<strong class="purchase-pop__head">' + card.head + '</strong>' +
        '<span class="purchase-pop__sub">' + card.sub + '</span></span></div>')) + (card.extra || '') +
        (btns.length ? '<div class="purchase-pop__btns">' + btns.join('') + '</div>' : '') +
        (card.fine ? '<p class="purchase-pop__fine">' + card.fine + '</p>' : '');
      el.setAttribute('data-card', card.name);
      el.classList.toggle('purchase-pop--dark', card.tone === 'dark');
    }

    /* Positioning under the live bottom of the sticky header, as before:
       the announcement bar is not sticky, so the stack is taller at the top
       of the page than once the nav has stuck. */
    function place2() {
      var hdr = document.getElementById('shopify-section-header') || qs('.site-header');
      var bottom = hdr ? hdr.getBoundingClientRect().bottom : 82;
      el.style.setProperty('--pop-top', Math.round(Math.max(0, bottom) + 14) + 'px');
    }
    var queued = false;
    function placeSoon() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; place2(); });
    }

    function setOut() {
      el.classList.remove('is-in');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('inert', '');
    }
    function setIn() {
      el.removeAttribute('aria-hidden');
      el.removeAttribute('inert');
      el.classList.add('is-in');
    }
    el.hidden = false;
    setOut();
    place2();
    window.addEventListener('scroll', placeSoon, { passive: true });
    window.addEventListener('resize', placeSoon);

    /* What each shopper saw and did, written onto their cart like the
       Entry stamp, so every order and checkout carries it:
         Owners cards seen    "Just bought · Pair · Casper, WY › Running low"
         Owners card actions  "Closed: Running low › Added: Map · Single · Macon, GA"
       It appends to whatever the cart already holds, so a shopper who comes
       back over several visits keeps the whole story. Kept under 480
       characters by dropping the oldest entries. */
    var LOG_SEEN = 'Owners cards seen', LOG_DID = 'Owners card actions', SEP = ' \u203a ';
    var log = null, logReady = null, current = '';
    function splitLog(v) { return v ? String(v).split(SEP) : []; }
    function loadLog() {
      if (!logReady) {
        logReady = fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var a = (c && c.attributes) || {};
          log = { seen: splitLog(a[LOG_SEEN]), did: splitLog(a[LOG_DID]) };
        }).catch(function () { log = { seen: [], did: [] }; });
      }
      return logReady;
    }
    function capLog(arr) {
      var out = arr.join(SEP);
      while (out.length > 480 && arr.length > 1) { arr.shift(); out = arr.join(SEP); }
      return out;
    }
    function logEvent(kind, text) {
      return loadLog().then(function () {
        log[kind].push(text);
        var attrs = {};
        attrs[LOG_SEEN] = capLog(log.seen);
        attrs[LOG_DID] = capLog(log.did);
        return stampCart(attrs);
      });
    }

    var HOLD = 8000, GAP_MIN = 25000, GAP_RANGE = 15000;
    var holdTimer = null, hovering = false;
    el.addEventListener('mouseenter', function () { hovering = true; });
    el.addEventListener('mouseleave', function () { hovering = false; });

    function stop() {
      stopped = true;
      clearTimeout(holdTimer);
      setOut();
    }
    var dismiss = el.querySelector('[data-purchase-pop-dismiss]');
    if (dismiss) dismiss.addEventListener('click', function () { stop(); sset(STOP_KEY, '1'); logEvent('did', 'Closed: ' + current); });

    /* The next card in this visit's plan that hasn't shown yet and whose
       data can back it. Used-up entries leave the plan. */
    function nextCard() {
      while (plan.length) {
        var id = plan.shift();
        sset(PLAN_KEY, JSON.stringify(plan));
        if (!BUILD[id] || used.indexOf(id) > -1) continue;
        var card = BUILD[id]();
        if (!card) continue;
        used.push(id);
        sset(USED_KEY, JSON.stringify(used));
        return card;
      }
      return null;
    }

    function leave() {
      if (hovering || el.contains(document.activeElement)) { holdTimer = setTimeout(leave, 1500); return; }
      setOut();
      if (shown < PER_VISIT && !stopped) setTimeout(show, GAP_MIN + Math.random() * GAP_RANGE);
    }
    function show() {
      if (stopped || shown >= PER_VISIT) return;
      if (document.hidden) { setTimeout(show, 4000); return; }
      var card = nextCard();
      if (!card) return;
      render(card);
      place2();
      setIn();
      current = card.log || card.name;
      logEvent('seen', current);
      shown++;
      sset(SHOWN_KEY, String(shown));
      holdTimer = setTimeout(leave, 900 + HOLD);
    }

    /* Off the product page the buttons are links: log the tap, then go
       (never held up more than a moment). */
    body.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.purchase-pop__btn');
      if (!a) return;
      e.preventDefault();
      var href = a.getAttribute('href');
      var gone = false;
      var go = function () { if (!gone) { gone = true; window.location.href = href; } };
      logEvent('did', 'Shop link: ' + current).then(go, go);
      window.setTimeout(go, 1200);
    });

    /* Adding from the card: the same request, drawer and Entry stamp the
       product form uses. If the add fails, go to the product page rather
       than leave the shopper with a button that did nothing. */
    body.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-op-add]');
      if (!b || b.disabled) return;
      var raw = b.getAttribute('data-op-add');
      var ids = raw === 'selected' ? [selectedVariantId()] : raw.split(',').map(Number);
      ids = ids.filter(Boolean);
      if (!ids.length) {
        /* No interior chosen yet: put the card away and point at the
           picker, the same nudge the Add to bag button gives. */
        clearTimeout(holdTimer);
        setOut();
        if (shown < PER_VISIT && !stopped) setTimeout(show, GAP_MIN + Math.random() * GAP_RANGE);
        nudgeMissingOptions(productForm || document);
        logEvent('did', 'Tapped, no interior chosen: ' + current);
        return;
      }
      b.disabled = true;
      b.classList.add('is-busy');
      var name = el.getAttribute('data-card') || 'card';
      postCart(routes.cartAddUrl || '/cart/add.js', {
        items: ids.map(function (id) { return { id: id, quantity: 1 }; }),
        sections: 'cart-drawer'
      }).then(function (data) {
        if (!data || data.status) throw new Error('add failed');
        stampCart({ 'Entry': 'Owners card (' + name + ')' });
        var label = b.getAttribute('data-op-label');
        logEvent('did', 'Added: ' + current + (label ? ' · ' + label : ''));
        renderCartDrawer(data.sections);
        fetchCartAndRender();
        stop();
        sset(STOP_KEY, '1');
        openCartDrawer(null);
      }).catch(function () {
        window.location.href = cfg.productUrl + (ids.length === 1 ? '?variant=' + ids[0] : '');
      });
    });

    /* First card once the visitor has scrolled a screen, or after 12
       seconds, whichever comes first. */
    var started = false;
    function start() {
      if (started) return;
      started = true;
      window.removeEventListener('scroll', onScroll);
      setTimeout(show, 600);
    }
    function onScroll() { if (window.scrollY > (window.innerHeight || 700) * 0.9) start(); }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(start, forced ? 300 : 12000);
  })();
})();
